var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 766.12 654.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13{stroke-width:0px;}.cls-14{opacity:.1;}.cls-3{fill:#bfbfbf;}.cls-4{fill:#b6e5ff;}.cls-5{fill:#bababa;}.cls-15,.cls-13{fill:#fff;}.cls-16,.cls-11{fill:#001321;}.cls-6{fill:#2ca2ff;}.cls-17{clip-path:url(#clippath-1);}.cls-7{fill:#000;}.cls-8{fill:#999;}.cls-9{fill:#5ae4a7;}.cls-10{fill:#e5e5e5;}.cls-18{opacity:.2;}.cls-19{opacity:.5;}.cls-12{fill:#757575;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M544.24,556.92l.19-73.16c.8-2.96,1.43-13.81,3.13-21.38,2.87-12.68-8.45-27.97-9.25-28.46-3.17-1.98-9.92-1.95-9.92-1.95,0,0-6.57-7.56-12.52-9.95-5.93-2.37-12.68-1.58-12.68-1.58,0,0-7.53-6.34-15.05-9.12-7.53-2.76-12.68,2.39-12.68,2.39l-7.4,11.53c-2.18,3.4-1.88,7.95,1.01,10.79,3.54,3.49,8.08,1.86,10.36,1.86,3.17,0,4.36-3.58,4.36-3.58,0,0,.78,18.63,0,21.01l-.02.02c-.81,2.37-6.73,7.92-6.73,7.92l-19.8-26.21c-5.74-7.58-13.87-20.78-17.84-29.42-.58-1.26-1.29-2.44-2.23-3.47-3.47-3.93-10.91-5.08-12.84,2.2-.51,1.95-.34,5.12.32,7.01,8.29,24.46,18.83,42.95,28.44,62.22,5.72,11.44,3.6,11.3,6.45,16.47-.34.23-.18.66-.53.87-1.4,5.56-2.37,11.14-3.77,16.7-1.35-6.68-3.15-14.13-6.34-20.16.64-3.9,1.26-7.85.87-11.78-.37-3.93-1.9-7.9-4.91-10.45-1.56-1.31-3.67-2.11-5.77-2.25-3.13-.23-5.9,2.05-6.36,5.15-.44,2.94-.85,6.52-1.66,8.96-2.5,7.54-4.57,10.98-4.57,11.25,0,7.39,4.57,6.18,7.9,35.88,2.59,23.13,32.38,38.42,48.6,55.12l17.29,54.37c20.07-8.04,39.27-18.33,57.69-30.29l-13.73-48.51Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M361.39,470.76c-.71-3.28-5.37-2.8-5.37-2.8-15.64.92-17.75,25.43-17.75,25.43l-5.6,16.79-1.75-25.26.18-32.55s4.73-31.15,2.62-36.04c-2.09-4.91-6.46-4.73-6.46-4.73-9.1-2.28-9.63,10.84-9.63,10.84l-7.69,26.78-3.15,28.89-2.62-1.4s-1.24-30.64-.71-31.15c.53-.53,3.68-21.18,3.68-21.18,0,0,1.74-3.84,3.84-8.75,2.09-4.91,0-8.75,0-8.75-3.68-7.53-11.37-4.02-12.95,0-1.58,4.02-6.31,11.9-6.31,11.9l-8.77,23.98c.34,5.42-2.78,32.2-2.78,32.2l-3.15-1.43-5.08-15.73,3.86-16.1s8.4-9.26,7-14.7c-1.4-5.42-8.57-3.84-8.57-3.84l-14.35,17.14h-4.22l-9.97,12.61c-2.69,8.15-4.06,16.63-4.06,25.15,0,5.58.58,11.19,1.77,16.7l2.28,10.64v68.79s-6.82,11.02-6.82,12.06c0,.48-2.82,9.17-6.75,20.01,17.16,10.1,31.95,17.91,42.42,22.03,4.92,1.95,9.9,3.81,14.9,5.58,6.29-17.66,13.64-36.56,17.69-40.97,8.04-8.75,23.79-25.56,23.79-25.56,0,0,17.91-28.75,20-38.31,1.74-7.85,5.93-22.09,7.39-26.97.34-1.1.48-2.27.41-3.42-.12-2.59-.37-7.6-.37-12.03,0-6.31,3.74-12.61,3.05-15.87Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M766.12,320.81c0,15.91-1.74,31.75-5.51,47.14-1.24,5.06-2.73,10.11-4.44,15.08-.5,1.42-.99,2.85-1.52,4.25-.43,1.16-.88,2.32-1.32,3.46-.13.31-.25.63-.38.94-.48,1.19-.96,2.38-1.47,3.56-.08.18-.17.38-.25.58-.5,1.16-1.01,2.32-1.52,3.46-.23.51-.46,1.01-.7,1.51-.46,1.03-.94,2.04-1.44,3.05-.51,1.08-1.04,2.14-1.57,3.19-.2.38-.38.76-.58,1.13-.46.91-.94,1.82-1.41,2.73-.38.71-.76,1.41-1.14,2.1-1.75,3.24-3.59,6.44-5.51,9.6-.78,1.29-1.57,2.58-2.38,3.86-.18.31-.38.63-.58.94-.93,1.46-1.87,2.91-2.83,4.37-.78,1.18-1.56,2.35-2.37,3.53-.7,1.03-1.39,2.04-2.1,3.06-.15.22-.3.43-.46.65-.73,1.06-1.49,2.12-2.23,3.18-.93,1.31-1.87,2.58-2.81,3.87-.2.26-.38.53-.58.78-1.08,1.47-2.18,2.93-3.28,4.37-.66.86-1.32,1.74-2,2.58-1.19,1.57-2.42,3.13-3.66,4.68-1.18,1.49-2.37,2.96-3.58,4.44-.13.17-.26.31-.4.48-1.19,1.47-2.38,2.93-3.61,4.39-.35.45-.73.89-1.09,1.32-1.11,1.34-2.23,2.68-3.36,4.01-3.24,3.84-6.52,7.65-9.82,11.42-6.7,7.71-13.56,15.38-20.54,22.99-5.81,6.29-11.7,12.55-17.71,18.69-28.83,29.61-60.05,57.24-94,79.25-4.22,2.73-8.47,5.4-12.78,7.93-1.57.93-3.14,1.85-4.72,2.76-.26.15-.55.31-.81.46-1.62.93-3.24,1.84-4.88,2.73-1.67.93-3.34,1.84-5.03,2.71l-2.28,1.19c-3.29,1.72-6.62,3.38-9.98,4.97-1.8.86-3.61,1.69-5.43,2.5-1.67.76-3.36,1.51-5.05,2.23-.7.3-1.37.6-2.07.88-1.54.66-3.1,1.29-4.65,1.92-3,1.21-6.02,2.37-9.07,3.46-1.16.43-2.33.84-3.51,1.26-.66.23-1.32.45-1.99.68-1.09.36-2.18.73-3.28,1.08-.94.31-1.9.61-2.85.91-.03.02-.07.02-.1.03-1.87.58-3.74,1.14-5.61,1.69-2.96.86-5.93,1.66-8.9,2.42-1.97.5-3.94.96-5.93,1.41-1.87.43-3.74.83-5.63,1.22-.15.03-.3.07-.45.08-1.95.4-3.92.78-5.89,1.13-1.01.18-2,.35-3.01.51s-2.02.33-3.05.48c-.91.15-1.84.28-2.75.4-1.11.17-2.23.31-3.34.46-11.77,1.51-23.57,2.14-35.37,2-.71,0-1.41-.02-2.12-.03-10.69-.2-21.38-1.03-32.03-2.4-.78-.1-1.56-.2-2.33-.31-1.34-.18-2.68-.36-4.02-.56l-3.13-.5c-4.42-.7-8.81-1.49-13.19-2.38-.98-.18-1.94-.38-2.9-.6-2.95-.61-5.91-1.27-8.84-1.97-1.97-.46-3.92-.94-5.88-1.44-.98-.25-1.95-.5-2.93-.76-.98-.25-1.95-.51-2.93-.78-3.89-1.04-7.76-2.17-11.62-3.34-4.49-1.36-8.94-2.8-13.37-4.32-1.61-.55-3.23-1.11-4.83-1.67-4.98-1.77-9.96-3.64-14.88-5.58-.88-.35-1.77-.71-2.7-1.09-.71-.3-1.42-.61-2.17-.94-.48-.22-.96-.43-1.46-.66-3.21-1.46-6.7-3.16-10.46-5.08-.63-.33-1.27-.66-1.92-.99-2.3-1.21-4.7-2.48-7.17-3.84-5.18-2.85-10.73-5.99-16.55-9.42-66.22-38.96-167.6-112.09-191.4-139.81-1.21-1.41-2.38-2.83-3.56-4.27-.91-1.13-1.82-2.27-2.7-3.43-.81-1.04-1.61-2.09-2.38-3.16-.7-.93-1.37-1.87-2.04-2.83-.63-.88-1.26-1.77-1.87-2.66-.03-.07-.08-.13-.13-.2-.74-1.11-1.49-2.22-2.22-3.34-.7-1.08-1.39-2.15-2.05-3.24-.33-.51-.65-1.04-.96-1.57-.74-1.22-1.47-2.45-2.18-3.67t-.02-.03c-.76-1.36-1.52-2.71-2.27-4.09-1.29-2.4-2.53-4.82-3.69-7.27-.3-.63-.6-1.27-.89-1.9-2.35-5.03-4.42-10.16-6.19-15.38-.65-1.82-1.22-3.66-1.79-5.5-.71-2.37-1.36-4.75-1.95-7.13-.12-.48-.23-.94-.33-1.42-.3-1.24-.58-2.5-.83-3.76-.38-1.75-.7-3.51-.99-5.28-.07-.43-.15-.86-.2-1.29-.15-.91-.28-1.82-.4-2.75-.15-1.09-.28-2.2-.4-3.29-.05-.38-.08-.74-.12-1.11-.1-.94-.17-1.89-.25-2.81,0-.08,0-.17-.02-.23-.08-1.13-.15-2.23-.18-3.34-.02-.12-.02-.22-.02-.31-.05-1.18-.08-2.35-.1-3.53,0-.44,0-.87,0-1.31,0-.69,0-1.38,0-2.06.02-1.73.07-3.46.17-5.18.07-1.13.15-2.25.25-3.36.2-2.22.46-4.44.79-6.64.17-1.13.35-2.25.56-3.36.4-2.23.88-4.47,1.44-6.7,1.49-5.88,3.39-11.54,5.71-16.97,1.75-4.19,3.74-8.21,5.94-12.15.17-.33.36-.68.56-1.01,8.92-15.71,21.05-29.64,34.73-42.55,1.46-1.39,2.93-2.75,4.44-4.09,1.57-1.44,3.16-2.85,4.77-4.27.1-.08.2-.18.3-.26,2.57-2.25,5.16-4.47,7.8-6.67,4.06-3.39,8.18-6.72,12.33-10.03.13-.12.28-.22.41-.33,3.56-2.81,7.15-5.61,10.73-8.39,5.63-4.35,11.27-8.69,16.8-13.01,1.47-1.14,2.93-2.28,4.37-3.43,1.61-1.26,3.18-2.52,4.75-3.77,14.83-11.88,27.61-24.53,39.49-37.47,2.3-2.52,4.58-5.05,6.85-7.6,1.08-1.22,2.15-2.43,3.21-3.66,15.11-17.21,29.16-34.63,44.81-51.06,3.72-3.92,7.53-7.78,11.45-11.57,3.31-3.16,6.67-6.27,10.16-9.32,3.99-3.51,8.09-6.94,12.4-10.25,5.88-4.57,12.07-8.95,18.69-13.14,1.62-1.04,3.23-2.05,4.85-3.05,165.04-102.57,286.51-69.09,367.55,0,6.11,5.18,12,10.59,17.64,16.19,3.44,3.33,6.77,6.77,10,10.25.36.36.7.74,1.04,1.14,2.27,2.42,4.47,4.85,6.62,7.3.65.73,1.27,1.46,1.9,2.18.94,1.09,1.89,2.18,2.81,3.29,1.14,1.34,2.27,2.7,3.39,4.06.71.86,1.41,1.72,2.1,2.58,4.52,5.56,8.82,11.21,12.93,16.88.83,1.13,1.64,2.27,2.45,3.41,5.66,7.94,10.92,15.97,15.81,23.95.7,1.14,1.39,2.28,2.07,3.41.7,1.14,1.37,2.28,2.04,3.43.66,1.13,1.32,2.27,1.97,3.39.66,1.14,1.31,2.27,1.94,3.39s1.26,2.27,1.89,3.39c.65,1.13,1.26,2.25,1.84,3.36.61,1.13,1.21,2.25,1.8,3.36s1.18,2.23,1.75,3.34c.56,1.11,1.14,2.22,1.7,3.31.56,1.11,1.11,2.22,1.66,3.31,2.17,4.37,4.22,8.69,6.17,12.94.96,2.15,1.92,4.29,2.83,6.39,4.12,9.47,7.65,18.52,10.53,26.95.02.03.03.08.03.12.28.81.55,1.61.81,2.4.28.83.55,1.64.81,2.45.2.63.41,1.24.6,1.87.3.93.6,1.85.88,2.8.31,1.01.61,2.02.89,3.03.55,1.85,1.08,3.71,1.57,5.58.43,1.57.84,3.14,1.24,4.73.08.3.17.58.23.88.07.25.12.5.18.74.23.93.46,1.85.68,2.8.6,2.47,1.14,4.95,1.66,7.43.28,1.36.56,2.7.81,4.06.05.25.1.5.15.76.25,1.27.48,2.55.7,3.82.3,1.7.58,3.43.83,5.13.22,1.29.4,2.6.58,3.91.02.18.05.38.08.58.12.86.23,1.74.33,2.62.1.73.18,1.46.26,2.17.3,2.63.56,5.25.78,7.88l.15,1.79c.07.99.13,2,.2,3,.07,1.11.13,2.22.18,3.34.05.86.08,1.7.12,2.57.05,1.26.08,2.53.1,3.79.03,1.46.05,2.93.05,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M766.12,320.81c0,15.91-1.74,31.75-5.51,47.14-1.24,5.06-2.73,10.11-4.44,15.08-.5,1.42-.99,2.85-1.52,4.25-.43,1.16-.88,2.32-1.32,3.46-.13.31-.25.63-.38.94-.48,1.19-.96,2.38-1.47,3.56-.08.18-.17.38-.25.58-.5,1.16-1.01,2.32-1.52,3.46-.23.51-.46,1.01-.7,1.51-.46,1.03-.94,2.04-1.44,3.05-.51,1.08-1.04,2.14-1.57,3.19-.2.38-.38.76-.58,1.13-.46.91-.94,1.82-1.41,2.73-.38.71-.76,1.41-1.14,2.1-1.75,3.24-3.59,6.44-5.51,9.6-.78,1.29-1.57,2.58-2.38,3.86-.18.31-.38.63-.58.94-.93,1.46-1.87,2.91-2.83,4.37-.78,1.18-1.56,2.35-2.37,3.53-.7,1.03-1.39,2.04-2.1,3.06-.15.22-.3.43-.46.65-.73,1.06-1.49,2.12-2.23,3.18-.93,1.31-1.87,2.58-2.81,3.87-.2.26-.38.53-.58.78-1.08,1.47-2.18,2.93-3.28,4.37-.66.86-1.32,1.74-2,2.58-1.19,1.57-2.42,3.13-3.66,4.68-1.18,1.49-2.37,2.96-3.58,4.44-.13.17-.26.31-.4.48-1.19,1.47-2.38,2.93-3.61,4.39-.35.45-.73.89-1.09,1.32-1.11,1.34-2.23,2.68-3.36,4.01-3.24,3.84-6.52,7.65-9.82,11.42-6.7,7.71-13.56,15.38-20.54,22.99-5.81,6.29-11.7,12.55-17.71,18.69-28.83,29.61-60.05,57.24-94,79.25-4.22,2.73-8.47,5.4-12.78,7.93-1.57.93-3.14,1.85-4.72,2.76-.26.15-.55.31-.81.46-1.62.93-3.24,1.84-4.88,2.73-1.67.93-3.34,1.84-5.03,2.71l-2.28,1.19c-3.29,1.72-6.62,3.38-9.98,4.97-1.8.86-3.61,1.69-5.43,2.5-1.67.76-3.36,1.51-5.05,2.23-.7.3-1.37.6-2.07.88-1.54.66-3.1,1.29-4.65,1.92-3,1.21-6.02,2.37-9.07,3.46-1.16.43-2.33.84-3.51,1.26-.66.23-1.32.45-1.99.68-1.09.36-2.18.73-3.28,1.08-.94.31-1.9.61-2.85.91-.03.02-.07.02-.1.03-1.87.58-3.74,1.14-5.61,1.69-2.96.86-5.93,1.66-8.9,2.42-1.97.5-3.94.96-5.93,1.41-1.87.43-3.74.83-5.63,1.22-.15.03-.3.07-.45.08-1.95.4-3.92.78-5.89,1.13-1.01.18-2,.35-3.01.51s-2.02.33-3.05.48c-.91.15-1.84.28-2.75.4-1.11.17-2.23.31-3.34.46-11.77,1.51-23.57,2.14-35.37,2-.71,0-1.41-.02-2.12-.03-10.69-.2-21.38-1.03-32.03-2.4-.78-.1-1.56-.2-2.33-.31-1.34-.18-2.68-.36-4.02-.56l-3.13-.5c-4.42-.7-8.81-1.49-13.19-2.38-.98-.18-1.94-.38-2.9-.6-2.95-.61-5.91-1.27-8.84-1.97-1.97-.46-3.92-.94-5.88-1.44-.98-.25-1.95-.5-2.93-.76-.98-.25-1.95-.51-2.93-.78-3.89-1.04-7.76-2.17-11.62-3.34-4.49-1.36-8.94-2.8-13.37-4.32-1.61-.55-3.23-1.11-4.83-1.67-4.98-1.77-9.96-3.64-14.88-5.58-.88-.35-1.77-.71-2.7-1.09-.71-.3-1.42-.61-2.17-.94-.48-.22-.96-.43-1.46-.66-3.21-1.46-6.7-3.16-10.46-5.08-.63-.33-1.27-.66-1.92-.99-2.3-1.21-4.7-2.48-7.17-3.84-5.18-2.85-10.73-5.99-16.55-9.42-66.22-38.96-167.6-112.09-191.4-139.81-1.21-1.41-2.38-2.83-3.56-4.27-.91-1.13-1.82-2.27-2.7-3.43-.81-1.04-1.61-2.09-2.38-3.16-.7-.93-1.37-1.87-2.04-2.83-.63-.88-1.26-1.77-1.87-2.66-.03-.07-.08-.13-.13-.2-.74-1.11-1.49-2.22-2.22-3.34-.7-1.08-1.39-2.15-2.05-3.24-.33-.51-.65-1.04-.96-1.57-.74-1.22-1.47-2.45-2.18-3.67t-.02-.03c-.76-1.36-1.52-2.71-2.27-4.09-1.29-2.4-2.53-4.82-3.69-7.27-.3-.63-.6-1.27-.89-1.9-2.35-5.03-4.42-10.16-6.19-15.38-.65-1.82-1.22-3.66-1.79-5.5-.71-2.37-1.36-4.75-1.95-7.13-.12-.48-.23-.94-.33-1.42-.3-1.24-.58-2.5-.83-3.76-.38-1.75-.71-3.51-.99-5.28-.07-.43-.15-.86-.2-1.29-.15-.91-.28-1.82-.4-2.75-.15-1.09-.28-2.2-.4-3.29-.05-.38-.08-.74-.12-1.11-.1-.94-.17-1.89-.25-2.81,0-.08,0-.17-.02-.23-.08-1.13-.15-2.23-.18-3.34-.02-.12-.02-.22-.02-.31-.05-1.18-.08-2.35-.1-3.53-.05-2.86.02-5.71.18-8.56.07-1.13.15-2.25.25-3.36.2-2.22.46-4.44.79-6.64.17-1.13.35-2.25.56-3.36.4-2.23.88-4.47,1.44-6.7,1.49-5.88,3.39-11.54,5.71-16.97,1.75-4.19,3.74-8.21,5.94-12.15.17-.33.36-.68.56-1.01,8.92-15.71,21.05-29.64,34.73-42.55.78-.74,1.56-1.47,2.35-2.2l2.09-1.89c1.57-1.44,3.16-2.85,4.77-4.27.1-.08.2-.18.3-.26,2.57-2.25,5.16-4.47,7.8-6.67,4.06-3.39,8.18-6.72,12.33-10.03.13-.12.28-.22.41-.33,3.56-2.81,7.15-5.61,10.73-8.39,1.8-1.39,3.59-2.78,5.4-4.17,3.82-2.95,7.65-5.89,11.4-8.84,1.47-1.14,2.93-2.28,4.37-3.43,1.61-1.26,3.18-2.52,4.75-3.77,14.83-11.88,27.61-24.53,39.49-37.47,2.3-2.52,4.58-5.05,6.85-7.6,1.08-1.22,2.15-2.43,3.21-3.66,15.11-17.21,29.16-34.63,44.81-51.06,3.72-3.92,7.53-7.78,11.45-11.57,3.31-3.16,6.67-6.27,10.16-9.32,3.99-3.51,8.09-6.94,12.4-10.25,5.88-4.57,12.07-8.95,18.69-13.14,1.62-1.04,3.23-2.05,4.85-3.05,165.04-102.57,286.51-69.09,367.55,0,6.11,5.18,12,10.59,17.64,16.19,3.44,3.33,6.77,6.77,10,10.25.36.36.7.74,1.04,1.14,2.27,2.42,4.47,4.85,6.62,7.3.65.73,1.27,1.46,1.9,2.18.94,1.09,1.89,2.18,2.81,3.29,1.14,1.34,2.27,2.7,3.39,4.06.71.86,1.41,1.72,2.1,2.58,4.52,5.56,8.82,11.21,12.93,16.88.83,1.13,1.64,2.27,2.45,3.41,5.66,7.94,10.92,15.97,15.81,23.95.7,1.14,1.39,2.28,2.07,3.41.7,1.14,1.37,2.28,2.04,3.43.66,1.13,1.32,2.27,1.97,3.39.66,1.14,1.31,2.27,1.94,3.39s1.26,2.27,1.89,3.39c.65,1.13,1.26,2.25,1.84,3.36.61,1.13,1.21,2.25,1.8,3.36s1.18,2.23,1.75,3.34c.56,1.11,1.14,2.22,1.7,3.31.56,1.11,1.11,2.22,1.66,3.31,2.18,4.37,4.24,8.69,6.17,12.94.96,2.15,1.92,4.29,2.83,6.39,4.12,9.47,7.65,18.52,10.53,26.95.02.03.03.08.03.12.28.81.55,1.61.81,2.4.28.83.55,1.64.81,2.45.2.63.41,1.24.6,1.87.3.93.6,1.85.88,2.8.31,1.01.61,2.02.89,3.03.55,1.85,1.08,3.71,1.57,5.58.43,1.57.84,3.14,1.24,4.73.08.3.17.58.23.88.07.25.12.5.18.74.23.93.46,1.85.68,2.8.6,2.47,1.14,4.95,1.66,7.43.28,1.36.56,2.7.81,4.06.05.25.1.5.15.76.25,1.27.48,2.55.7,3.82.3,1.7.58,3.43.83,5.13.22,1.29.4,2.6.58,3.91.02.18.05.38.08.58.12.86.23,1.74.33,2.62.1.73.18,1.46.26,2.17.3,2.63.56,5.25.78,7.88l.15,1.79c.07.99.13,2,.2,3,.07,1.11.13,2.22.18,3.34.05.86.08,1.7.12,2.57.05,1.26.08,2.53.1,3.79.03,1.46.05,2.93.05,4.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.79,333.41c-1.69,11.26-10,20.41-20.81,23.95l-4.1,1.34c-14.76,20.9-40.65,29.83-62.71,16.87l-6.46-3.79-18.07-21.48c-.07.02-.15.03-.22.05-5.73,1.19-12.2.31-16.44-3.72-.68,3.54-5.3,5.63-8.39,3.81s-3.49-6.89-.73-9.19c-3.64,3.21-9.27,1.74-12.78-1.77-.15-9.58.86-19.17,3.23-28.62,1.49-5.88,3.39-11.54,5.71-16.97,1.75-4.19,3.74-8.21,5.94-12.15.17-.33.36-.68.56-1.01,3.26-5.76,6.95-11.27,11.01-16.58l2.09-1.89c1.57-1.44,3.16-2.85,4.77-4.27.1-.08.2-.18.3-.26,2.57-2.25,5.16-4.47,7.8-6.67,4.06-3.39,8.18-6.72,12.33-10.03.13-.12.28-.22.41-.33,3.56-2.81,7.15-5.61,10.73-8.39,1.8-1.39,3.59-2.78,5.4-4.17,1.09.13,2.15.38,3.18.74,4.42,1.54,5.18,5.59,8.24,8.38,4.07,3.72,7.98-2.53,14.25-2.33,19.28.6,11.8,20.38,21.22,17.89,40.67-10.73,33.83,41.3,16.15,52.72,10.43,8.64,19.42,14.35,17.4,27.89Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 89.34,
    cy: 315.12,
    rx: 68.59,
    ry: 67.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M89.34,383.68c-38.28,0-69.42-30.76-69.42-68.57s31.14-68.57,69.42-68.57,69.42,30.76,69.42,68.57-31.14,68.57-69.42,68.57ZM89.34,248.21c-37.36,0-67.76,30.02-67.76,66.91s30.4,66.91,67.76,66.91,67.76-30.02,67.76-66.91-30.4-66.91-67.76-66.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 89.34,
    cy: 312.38,
    rx: 62.54,
    ry: 61.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M89.34,374.97c-34.94,0-63.37-28.08-63.37-62.59s28.43-62.59,63.37-62.59,63.37,28.08,63.37,62.59-28.43,62.59-63.37,62.59ZM89.34,251.44c-34.03,0-61.71,27.34-61.71,60.94s27.68,60.94,61.71,60.94,61.71-27.34,61.71-60.94-27.68-60.94-61.71-60.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M22.14,336.72c-3.94,2.45-5.07,10.68-1.96,14.24,3.11,3.55,9.03.81,10.25-4.75.57,1.56,2.4,1.81,3.34.47.66-.96.69-2.46.23-3.48-.3-.25-.19-.43,0,0,2.01,1.6,5.49-.14,5.97-3.57-1.47,9.1,6.8,17.04,12.89,12.42-1.8,3.87.56,8.95,3.71,9.93,3.14.98,6.52-.88,9.54-2.94,3.01-2.06,6.09-4.42,9.39-4.56,2.87-.14,5.53,1.48,8.27,2.45,8.71,3.03,18.9-.98,25.56-10.11,4.4,7.53,15.24,4.76,18.15-4.62.61,4.39,3.62,7.73,6.97,7.78,3.35.04,6.73-3.21,7.88-7.57v.06c.07,4.15,3.78,6.19,6.43,3.52,3.38-3.41,5.48-9.67,3.82-14.68,4.51-.18,8.88-5.41,9.56-11.47.7-6.06-2.36-12.14-6.71-13.33,7.47-3.1,13.32-13.27,13.6-23.66.26-10.37-5.06-20.01-12.4-22.43-2.79-.92-6.06-.74-8.42,1.76-.87-5.91-3.55-11.19-7.5-13.84-6.29-4.25-15.05-1.34-19.73,6.58,2.28-4.09,2.44-10,.36-13.88-2.08-3.86-6.21-5.41-9.72-3.58-.76-6.34-5.65-10.85-10.44-9.61-4.77,1.23-8.64,8-8.23,14.42-.45-5.17-6.54-6.44-8.74-2.11.19.39-.09.16,0,0-3.04-6.39-9.23-9.67-14.98-7.8-6.11,2-11.24,9.68-12.02,18.04-4.21-3.84-10.36-3.68-14.89.41-4.52,4.07-7.13,11.82-6.34,18.75-4.75-4.69-12.75-2.13-16.01,5.12-3.26,7.25-1.01,17.52,4.49,20.56-3.8.58-7.14,5.61-7.14,10.71.01,5.12,3.36,9.47,7.16,9.34-3.84.33-7.45,4.86-8.01,10.02-.56,5.17,2.01,10.32,5.68,11.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M85.19,312.99c-1.92-1.61-4.36-2.39-6.7-1.65-2.34.74-4.49,3.16-5.02,6.15-.53,2.99.85,6.3,3.15,6.87,2.79.69,5.65-2.43,8.5-2.09,1.02.12,1.94.68,2.93.96,4.08,1.15,8.22-2.52,11.68-5.97,1.22-1.21,2.47-2.47,3.3-4.13.83-1.66,1.17-3.84.44-5.44-1.01-2.23-3.49-2.42-5.56-1.99-4.16.86-8.21,3.24-11.53,6.78.12-.84.24-1.67.37-2.51l-1.57,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M144.98,304.83c-1.1-.93-2.23-1.87-3.54-2.19-1.32-.32-2.88.14-3.74,1.56-1.18,1.94-.51,4.83.92,6.22,1.43,1.39,3.36,1.69,5.19,1.94,1.89.26,4.27.2,5.25-1.99.71-1.59.2-3.61-.8-4.77-1-1.16-2.36-1.65-3.68-2.11l.4,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M51.39,271.01c-3.84,2.26-6.86,6.92-7.84,12.11-.3,1.57-.29,3.51.75,4.27.74.54,1.71.24,2.57-.08,3.66-1.33,7.33-2.65,10.99-3.98-1.76.96-3.56,1.96-4.98,3.63-1.42,1.67-2.4,4.2-1.99,6.48.49,2.68,2.79,4.21,4.98,4.03,2.2-.17,4.26-1.69,6.08-3.43,1.94-1.86,3.84-4.38,3.93-7.37.09-2.99-2.81-5.58-4.64-3.55,4.19-1.7,8.21-4.25,11.86-7.53,1.32-1.19,2.62-2.51,3.47-4.26.85-1.75,1.17-4.01.45-5.7-3.58-8.43-8.53,4.56-10.85,5.83-4.4,2.41-9.2-3.74-14.78-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M33.72,308.99c-.42,1.72-.19,3.74.87,4.77,1.06,1.03,2.98.55,3.51-1.13-2.46,1.12-5.08,2.4-6.65,5.11-1.57,2.71-1.28,7.27,1.13,8.13,1.5.54,3.14-.51,4.56-1.57,4.01-3,7.85-6.41,11.47-10.18-1.14,3.26,1.4,6.72,4.11,6.85,2.71.13,5.29-1.9,7.65-3.85,2.9-2.39,6.24-5.98,5.57-10.09-.59-3.58-4.19-4.96-7-3.73-2.81,1.23-4.96,4.23-6.97,7.1,1.58-2.94-.52-7.04-3.19-7.33-2.6-.29-5.24,1.9-6.91,4.44,3.08-2.31,3.86-7.9-.2-8.29-2.64-.26-7.26,6.89-7.95,9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M117.36,291.44c-2.28-.95-5.19,1.13-5.86,4.19-.67,3.06,1.04,6.4,3.46,6.73-1.78.3-3.51,1.54-4.69,3.36-.66,1.01-1.16,2.29-1.04,3.54.18,1.86,1.72,3,3.21,2.98,1.48-.02,2.91-.91,4.28-1.78-1.47.27-3.03.58-4.21,1.8-1.18,1.22-1.73,3.69-.71,4.95.85,1.05,2.3.78,3.49.29,2.68-1.11,5.19-3.05,7.25-5.58,1.48,2.05,3.7,3.46,5.94,2.85,2.24-.6,4.19-3.75,3.54-6.45-.46-1.93-2.05-3.06-3.64-3.21-1.6-.15-3.21.51-4.76,1.24,1.6-1.52,3.29-3.21,3.91-5.59.62-2.38-.57-5.45-2.5-5.15-2.17.35-3.34,4.17-5.07,5.62-2.06-2.39,1.98-7.87-2.6-9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M78.63,282.37c-2.5,2.27-3.42,6.51-3.32,10.28.11,4.16,1.52,8.53,4.49,10.02,3.91,1.96,8.92-2.53,9.75-8,.82-5.46-1.86-10.81-5.64-13.11,0,0-2.77-1.47-5.27.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M106.3,276.17c.33.35.66.7,1,1.06-1.63-2.6-5.16-2.74-7.19-.28-2.03,2.46-2.13,6.98-.19,9.21,1.93,2.23,5.48,1.69,7.22-1.11,2.82,1.51,6.59.63,8.66-2.58,2.06-3.21,1.71-8.56-.99-10.37-2.7-1.81-6.91,1.41-6.7,5.39-.39-.54-.77-1.08-1.16-1.61l-.65.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M136.63,280.58c-2,2.57-4.08,5.31-4.85,8.73-.78,3.42.33,7.64,2.97,8.34,2.62.69,5.18-2.23,6.73-5.22,1.41-2.69,2.5-6.01,1.78-8.94-.73-2.92-4.05-4.48-5.77-2.09l-.85-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M93.13,262.89c-.94-2.77-4.08-3.56-6.17-1.8-2.09,1.77-2.92,5.5-2.07,8.33.85,2.82,3.13,4.63,5.54,4.82,2.99.23,6.58-3.07,5.97-6.77,1.25,2.09,3.55,2.81,5.68,2.41,2.13-.4,4.13-1.75,6-3.22,2.55-2,5.28-5.01,5.08-8.68-.16-2.92-2.34-5.04-4.64-5.17-2.3-.13-4.58,1.37-6.38,3.39-1.41,1.59-2.59,3.51-4.11,4.92-1.52,1.41-3.56,2.24-5.14,1.24l.22.53Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 209.91,
    y: 365.39,
    width: 381.8,
    height: 160.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M591.71,527.01H209.91c-.46,0-.83-.37-.83-.83v-160.8c0-.46.37-.83.83-.83h381.8c.46,0,.83.37.83.83v160.8c0,.46-.37.83-.83.83ZM210.74,525.36h380.14v-159.14H210.74v159.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 217.89,
    y: 375.12,
    width: 35.92,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M254.64,395.83h-37.58v-21.54h37.58v21.54ZM218.72,394.18h34.27v-18.23h-34.27v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 526.3,
    y: 472.05,
    width: 56.58,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M583.71,492.77h-58.23v-21.54h58.23v21.54ZM527.13,491.11h54.93v-18.23h-54.93v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 547.95,
    y: 399.95,
    width: 34.92,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M583.71,420.67h-36.58v-21.54h36.58v21.54ZM548.78,419.01h33.27v-18.23h-33.27v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 217.89,
    y: 447.53,
    width: 35.92,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M254.64,468.25h-37.58v-21.54h37.58v21.54ZM218.72,466.59h34.27v-18.23h-34.27v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 217.89,
    y: 423.59,
    width: 29.08,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M247.8,444.3h-30.73v-21.54h30.73v21.54ZM218.72,442.64h27.43v-18.23h-27.43v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 217.89,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M238.6,420.07h-21.54v-21.54h21.54v21.54ZM218.72,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 243.27,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M263.98,420.07h-21.54v-21.54h21.54v21.54ZM244.1,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 268.65,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M289.36,420.07h-21.54v-21.54h21.54v21.54ZM269.48,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 294.03,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M314.74,420.07h-21.54v-21.54h21.54v21.54ZM294.86,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 319.41,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M340.12,420.07h-21.54v-21.54h21.54v21.54ZM320.24,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 344.79,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M365.5,420.07h-21.54v-21.54h21.54v21.54ZM345.62,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 370.17,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M390.88,420.07h-21.54v-21.54h21.54v21.54ZM371,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 395.55,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M416.26,420.07h-21.54v-21.54h21.54v21.54ZM396.38,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 420.93,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M441.64,420.07h-21.54v-21.54h21.54v21.54ZM421.76,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 446.31,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M467.02,420.07h-21.54v-21.54h21.54v21.54ZM447.14,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 471.69,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M492.4,420.07h-21.54v-21.54h21.54v21.54ZM472.52,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 497.07,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M517.78,420.07h-21.54v-21.54h21.54v21.54ZM497.9,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 522.45,
    y: 399.35,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M543.16,420.07h-21.54v-21.54h21.54v21.54ZM523.28,418.41h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 217.89,
    y: 496.57,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M238.6,517.29h-21.54v-21.54h21.54v21.54ZM218.72,515.63h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 243.27,
    y: 496.57,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M263.98,517.29h-21.54v-21.54h21.54v21.54ZM244.1,515.63h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 268.65,
    y: 496.57,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M289.36,517.29h-21.54v-21.54h21.54v21.54ZM269.48,515.63h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 294.03,
    y: 496.57,
    width: 24.26,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M319.12,517.29h-25.92v-21.54h25.92v21.54ZM294.86,515.63h22.61v-18.23h-22.61v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 323.79,
    y: 496.57,
    width: 121.4,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M446.02,517.29h-123.06v-21.54h123.06v21.54ZM324.61,515.63h119.75v-18.23h-119.75v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 486.01,
    y: 496.57,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M506.72,517.29h-21.54v-21.54h21.54v21.54ZM486.84,515.63h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 511.39,
    y: 496.57,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M532.1,517.29h-21.54v-21.54h21.54v21.54ZM512.22,515.63h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 536.81,
    y: 496.57,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M557.52,517.29h-21.54v-21.54h21.54v21.54ZM537.64,515.63h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 450.16,
    y: 496.57,
    width: 30.87,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M481.86,517.29h-32.53v-21.54h32.53v21.54ZM450.99,515.63h29.22v-18.23h-29.22v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 562.99,
    y: 496.57,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M583.71,517.29h-21.54v-21.54h21.54v21.54ZM563.82,515.63h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 252.61,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M273.33,444.3h-21.54v-21.54h21.54v21.54ZM253.44,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 277.99,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M298.71,444.3h-21.54v-21.54h21.54v21.54ZM278.82,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 303.37,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M324.09,444.3h-21.54v-21.54h21.54v21.54ZM304.2,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 328.75,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M349.47,444.3h-21.54v-21.54h21.54v21.54ZM329.58,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 354.13,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M374.85,444.3h-21.54v-21.54h21.54v21.54ZM354.96,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 379.51,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M400.23,444.3h-21.54v-21.54h21.54v21.54ZM380.34,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 404.89,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M425.61,444.3h-21.54v-21.54h21.54v21.54ZM405.72,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 430.27,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M450.99,444.3h-21.54v-21.54h21.54v21.54ZM431.1,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 455.65,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M476.37,444.3h-21.54v-21.54h21.54v21.54ZM456.48,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 481.03,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M501.75,444.3h-21.54v-21.54h21.54v21.54ZM481.86,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 506.41,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M527.13,444.3h-21.54v-21.54h21.54v21.54ZM507.24,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 531.79,
    y: 423.59,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M552.51,444.3h-21.54v-21.54h21.54v21.54ZM532.62,442.64h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "582.88 423.59 582.88 467.71 563 467.71 563 443.47 557.17 443.47 557.17 423.59 582.88 423.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M583.71,468.53h-21.53v-24.24h-5.83v-21.54h27.37v45.77ZM563.83,466.88h18.23v-42.46h-24.06v18.23h5.83v24.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 258.43,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M279.15,468.53h-21.54v-21.54h21.54v21.54ZM259.26,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 283.81,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M304.53,468.53h-21.54v-21.54h21.54v21.54ZM284.64,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 309.19,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M329.91,468.53h-21.54v-21.54h21.54v21.54ZM310.02,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 334.57,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M355.29,468.53h-21.54v-21.54h21.54v21.54ZM335.4,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 359.95,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M380.67,468.53h-21.54v-21.54h21.54v21.54ZM360.78,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 385.33,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M406.05,468.53h-21.54v-21.54h21.54v21.54ZM386.16,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 410.71,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M431.43,468.53h-21.54v-21.54h21.54v21.54ZM411.54,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 436.09,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M456.81,468.53h-21.54v-21.54h21.54v21.54ZM436.92,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 461.47,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M482.19,468.53h-21.54v-21.54h21.54v21.54ZM462.3,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 486.85,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M507.57,468.53h-21.54v-21.54h21.54v21.54ZM487.68,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 512.23,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M532.95,468.53h-21.54v-21.54h21.54v21.54ZM513.06,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 537.61,
    y: 447.82,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M558.33,468.53h-21.54v-21.54h21.54v21.54ZM538.44,466.88h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 247.65,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M268.36,492.77h-21.54v-21.54h21.54v21.54ZM248.47,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 273.03,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.74,492.77h-21.54v-21.54h21.54v21.54ZM273.85,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 298.41,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M319.12,492.77h-21.54v-21.54h21.54v21.54ZM299.23,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 323.79,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M344.5,492.77h-21.54v-21.54h21.54v21.54ZM324.61,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 349.17,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M369.88,492.77h-21.54v-21.54h21.54v21.54ZM349.99,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 374.55,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M395.26,492.77h-21.54v-21.54h21.54v21.54ZM375.37,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 399.93,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M420.64,492.77h-21.54v-21.54h21.54v21.54ZM400.75,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 425.31,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M446.02,492.77h-21.54v-21.54h21.54v21.54ZM426.13,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 450.69,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M471.4,492.77h-21.54v-21.54h21.54v21.54ZM451.51,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 476.07,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M496.78,492.77h-21.54v-21.54h21.54v21.54ZM476.89,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 501.45,
    y: 472.05,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M522.16,492.77h-21.54v-21.54h21.54v21.54ZM502.27,491.11h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 258.43,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M279.15,397.03h-21.54v-21.54h21.54v21.54ZM259.26,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 283.81,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M304.53,397.03h-21.54v-21.54h21.54v21.54ZM284.64,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 309.19,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M329.91,397.03h-21.54v-21.54h21.54v21.54ZM310.02,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 334.57,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M355.29,397.03h-21.54v-21.54h21.54v21.54ZM335.4,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 359.95,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M380.67,397.03h-21.54v-21.54h21.54v21.54ZM360.78,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 385.33,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M406.05,397.03h-21.54v-21.54h21.54v21.54ZM386.16,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 410.71,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M431.43,397.03h-21.54v-21.54h21.54v21.54ZM411.54,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 436.09,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M456.81,397.03h-21.54v-21.54h21.54v21.54ZM436.92,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 461.47,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M482.19,397.03h-21.54v-21.54h21.54v21.54ZM462.3,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 486.85,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M507.57,397.03h-21.54v-21.54h21.54v21.54ZM487.68,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 512.23,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M532.95,397.03h-21.54v-21.54h21.54v21.54ZM513.06,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 537.61,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M558.33,397.03h-21.54v-21.54h21.54v21.54ZM538.44,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 562.99,
    y: 376.32,
    width: 19.89,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M583.71,397.03h-21.54v-21.54h21.54v21.54ZM563.82,395.38h18.23v-18.23h-18.23v18.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 217.89,
    y: 472.05,
    width: 24.09,
    height: 19.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M242.81,492.77h-25.75v-21.54h25.75v21.54ZM218.72,491.11h22.44v-18.23h-22.44v18.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "209.91 366.42 217.89 363.76 586.53 363.76 591.78 366.39 209.91 366.42"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M482.43,642.2l-7.76-46.76c-1.7-6.97-5.36-13.31-10.51-18.31-15.44-14.9-35.85-30.19-36.73-49.72-1.34-29.84-5.99-28.95-5.5-36.31.02-.26,2.32-3.56,5.31-10.92.96-2.38,1.61-5.93,2.25-8.84.66-3.06,3.58-5.15,6.69-4.72,2.09.28,4.14,1.22,5.61,2.63,2.83,2.75,4.09,6.8,4.2,10.76.12,3.94-.76,7.85-1.66,11.69,2.78,6.22,4.09,13.79,4.98,20.54,1.77-5.46,3.11-10.97,4.88-16.42.36-.2.23-.63.58-.83-2.5-5.36-.38-5.06-5.33-16.87-8.33-19.86-17.61-39.01-24.25-63.97-.53-1.94-.5-5.11.15-7.02,2.4-7.13,9.75-5.5,12.96-1.34.86,1.09,1.49,2.32,1.99,3.61,3.39,8.89,10.63,22.59,15.84,30.54l18.02,27.48s6.27-5.15,7.23-7.45l.02-.02c.94-2.32,1.41-20.97,1.41-20.97,0,0-1.42,3.49-4.58,3.29-2.28-.17-6.92,1.16-10.21-2.55-2.7-3.03-2.7-7.58-.3-10.82l8.16-11.02s5.48-4.8,12.81-1.54c7.32,3.28,14.42,10.1,14.42,10.1,0,0,6.79-.35,12.55,2.42,5.78,2.78,11.83,10.76,11.83,10.76,0,0,6.74.41,9.77,2.62.76.55,11.04,16.55,7.33,29.02-2.2,7.43-3.56,18.22-4.55,21.12l-5.05,72.98,10.18,48.03-21.76,12.13c-8,4.46-16.38,8.21-25.05,11.2l-15.94,5.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M544.24,556.92l.19-73.16c.8-2.96,1.43-13.81,3.13-21.38,2.87-12.68-8.45-27.97-9.25-28.46-3.17-1.98-9.92-1.95-9.92-1.95,0,0-6.57-7.56-12.52-9.95-5.93-2.37-12.68-1.58-12.68-1.58,0,0-7.53-6.34-15.05-9.12-7.53-2.76-12.68,2.39-12.68,2.39l-7.4,11.53c-2.18,3.4-1.88,7.95,1.01,10.79,3.54,3.49,8.08,1.86,10.36,1.86,3.17,0,4.36-3.58,4.36-3.58,0,0,.78,18.63,0,21.01l-.02.02c-.81,2.37-6.73,7.92-6.73,7.92l-19.8-26.21c-5.74-7.58-13.87-20.78-17.84-29.42-.58-1.26-1.29-2.44-2.23-3.47-3.47-3.93-10.91-5.08-12.84,2.2-.51,1.95-.34,5.12.32,7.01,8.29,24.46,18.83,42.95,28.44,62.22,5.72,11.44,3.6,11.3,6.45,16.47-.34.23-.18.66-.53.87-1.4,5.56-2.37,11.14-3.77,16.7-1.35-6.68-3.15-14.13-6.34-20.16.64-3.9,1.26-7.85.87-11.78-.37-3.93-1.9-7.9-4.91-10.45-1.56-1.31-3.67-2.11-5.77-2.25-3.13-.23-5.9,2.05-6.36,5.15-.44,2.94-.85,6.52-1.66,8.96-2.5,7.54-4.57,10.98-4.57,11.25,0,7.39,4.57,6.18,7.9,35.88,2.59,23.13,32.38,38.42,48.6,55.12l17.29,54.37c20.07-8.04,39.27-18.33,57.69-30.29l-13.73-48.51Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M535.76,457.5c.88-2.15,1.92-4.37,3.8-5.74s4.83-1.54,6.33.23c-1.24-3.8-2.55-7.57-3.93-11.31-1.06-2.85-2.25-5.82-4.6-7.74-2.35-1.92-6.23-2.33-8.25-.06,1.44,8.63,1.59,17.48.46,26.16-.61,4.7-1.4,10.1,1.76,13.63.87.71,2.38-.57,1.83-1.54-.26-.46-1.2-.49-1.6-.45,1.02-4.49,2.45-8.91,4.19-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M535.76,457.5c.88-2.15,1.92-4.37,3.8-5.74s4.83-1.54,6.33.23c-1.24-3.8-2.55-7.57-3.93-11.31-1.06-2.85-2.25-5.82-4.6-7.74-2.35-1.92-6.23-2.33-8.25-.06,1.44,8.63,1.59,17.48.46,26.16-.61,4.7-1.4,10.1,1.76,13.63.87.71,2.38-.57,1.83-1.54-.26-.46-1.2-.49-1.6-.45,1.02-4.49,2.45-8.91,4.19-13.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M535.76,457.5c.88-2.15,1.92-4.37,3.8-5.74s4.83-1.54,6.33.23c-1.24-3.8-2.55-7.57-3.93-11.31-1.06-2.85-2.25-5.82-4.6-7.74-2.35-1.92-6.23-2.33-8.25-.06,1.44,8.63,1.59,17.48.46,26.16-.61,4.7-1.4,10.1,1.76,13.63.87.71,2.38-.57,1.83-1.54-.26-.46-1.2-.49-1.6-.45,1.02-4.49,2.45-8.91,4.19-13.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M509.35,449.65c.12,3.18.1,6.41.89,9.5.78,3.09,2.5,6.1,5.29,7.64-1.64-6.17-.75-12.69.14-19.01.55-3.84,1.09-7.68,1.64-11.52.19-1.33.4-2.72,1.17-3.83s2.27-1.83,3.5-1.27c-1.63.97-3.76-.33-4.75-1.95-.99-1.63-1.38-3.59-2.54-5.09-2.21-2.84-6.95-3.47-10.22-2.72.99,9.45,4.5,18.48,4.88,28.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M509.35,449.65c.12,3.18.1,6.41.89,9.5.78,3.09,2.5,6.1,5.29,7.64-1.64-6.17-.75-12.69.14-19.01.55-3.84,1.09-7.68,1.64-11.52.19-1.33.4-2.72,1.17-3.83s2.27-1.83,3.5-1.27c-1.63.97-3.76-.33-4.75-1.95-.99-1.63-1.38-3.59-2.54-5.09-2.21-2.84-6.95-3.47-10.22-2.72.99,9.45,4.5,18.48,4.88,28.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M509.35,449.65c.12,3.18.1,6.41.89,9.5.78,3.09,2.5,6.1,5.29,7.64-1.64-6.17-.75-12.69.14-19.01.55-3.84,1.09-7.68,1.64-11.52.19-1.33.4-2.72,1.17-3.83s2.27-1.83,3.5-1.27c-1.63.97-3.76-.33-4.75-1.95-.99-1.63-1.38-3.59-2.54-5.09-2.21-2.84-6.95-3.47-10.22-2.72.99,9.45,4.5,18.48,4.88,28.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M482.33,424.14c-1.07-.79-1.42-2.19-1.75-3.48-.32-1.29-.78-2.69-1.94-3.34-5.08,3.22-2.31,12.67-7.44,15.81-1,.61-2.27.95-2.82,1.98-.5.93-.18,2.15.54,2.91.73.77,1.77,1.15,2.81,1.34,4.09.73,8.4-1.35,10.84-4.71,2.01-2.77,3.41-7.25,2.41-10.54-.78.43-1.89.6-2.65.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M429.49,486.01c-.09.35-.16.8.12,1.03.43.36,1.02-.2,1.34-.66,2.13-3.03,6.35-4.4,9.86-3.2,1.34-.03,1.79-2.06.92-3.08s-2.37-1.19-3.71-1.19c-1.34,0-2.77.07-3.91-.64-1.4-.87-1.94-2.65-1.59-4.17-.9,3.99-2.01,7.95-3.04,11.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M482.33,424.14c-1.07-.79-1.42-2.19-1.75-3.48-.32-1.29-.78-2.69-1.94-3.34-5.08,3.22-2.31,12.67-7.44,15.81-1,.61-2.27.95-2.82,1.98-.5.93-.18,2.15.54,2.91.73.77,1.77,1.15,2.81,1.34,4.09.73,8.4-1.35,10.84-4.71,2.01-2.77,3.41-7.25,2.41-10.54-.78.43-1.89.6-2.65.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M429.49,486.01c-.09.35-.16.8.12,1.03.43.36,1.02-.2,1.34-.66,2.13-3.03,6.35-4.4,9.86-3.2,1.34-.03,1.79-2.06.92-3.08s-2.37-1.19-3.71-1.19c-1.34,0-2.77.07-3.91-.64-1.4-.87-1.94-2.65-1.59-4.17-.9,3.99-2.01,7.95-3.04,11.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M496.88,422.88c-2.9-.39-5.96-.46-8.48-1.94-3.16-1.85-5.32-5.8-8.98-5.96-3.25-.14-5.67,2.84-7.51,5.51-.21-4.04,2.76-7.82,6.51-9.32,3.76-1.5,8.08-1.03,11.84.47,3.76,1.49,7.06,3.93,10.27,6.39,1.29.99,2.6,2.02,3.47,3.39,4.08,6.43-4.57,1.8-7.12,1.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M496.88,422.88c-2.9-.39-5.96-.46-8.48-1.94-3.16-1.85-5.32-5.8-8.98-5.96-3.25-.14-5.67,2.84-7.51,5.51-.21-4.04,2.76-7.82,6.51-9.32,3.76-1.5,8.08-1.03,11.84.47,3.76,1.49,7.06,3.93,10.27,6.39,1.29.99,2.6,2.02,3.47,3.39,4.08,6.43-4.57,1.8-7.12,1.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M445.1,516.88c.2-.36.37-.74.54-1.11-.35.27-.58.63-.54,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M450.02,491.24c-.33-4.08.26-8.18.09-12.27-.17-4.09-1.24-8.39-4.22-11.2-4.27-4.03-15.97-1.97-12.04,5.67,1.09,2.12,3.89,3.22,6.07,2.26s3.25-3.92,2.06-5.98c4.73,7.17,4.31,17.35-1,24.11,6.07,5.26,7.99,14.66,4.67,21.93.71-.54,1.95-.61,2.72-.03,1.16.87,1.55,2.4,2.11,3.74.56,1.34,1.66,2.73,3.11,2.63,1.99-4.87,1.33-10.42.04-15.52-1.29-5.1-3.19-10.1-3.61-15.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M492.84,414.48c-2.28-1.75-4.98-2.93-7.83-3.3l7.83,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M512.3,466.27c-.63-2.81-1.93-5.43-2.7-8.21-1.81-6.47-.67-13.39-1.5-20.06-1.07-8.62-5.57-16.77-12.3-22.27l-2.96-1.25c2.84,2.18,5.01,5.22,5.97,8.67,2.29,7.9,3.01,16.16,4.03,24.33,1.57,12.59,3.87,25.1,6.88,37.43,1.97-6.04,3.97-12.43,2.59-18.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M480.79,436.84c2.05-1.62,3.15-4.21,3.5-6.8.31-2.32.09-4.66-.19-6.99-.2,1-1.49,1.83-2.6,1.57-1.41-.33-2.34-1.64-3.13-2.85-.2.69-.4,1.39-.6,2.08-.08-.38-.16-.75-.24-1.13l-.79,1c1.17,3.32,2.3,7.18.49,10.2-.88,1.46-2.32,2.48-3.73,3.45,2.14,1.49,5.24,1.08,7.29-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M484,422.23c.03.27.06.55.1.82.05-.27.04-.55-.1-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M475.35,455.72c-5.8-11.4-11.61-22.81-17.99-33.9-3.73-6.48-7.68-12.89-12.66-18.48-2.2-2.48-8.54-8.21-12.03-4.43-2.33,2.52.73,7.1-2.13,9.82.66.04,3.89-.31,4.23.11,7.27,8.98,11.27,20.55,11.11,32.1,2.34-1.83,5.53.71,7.36,3.05,11.21,14.41,21.7,29.39,31.4,44.86-1.88-6.84-1.92-14.09-3.95-20.89-1.28-4.27-3.31-8.28-5.34-12.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M542.78,483.51c2.77-7.42,4.94-15.03,5.19-22.91.22-7.16-1.41-14.6-5.2-20.73-.96-1.55-4.93-7.89-7.11-7.38-3.89.92,1.22,7.67,2.11,9.36,3.36,6.37,6.8,13.11,6.59,20.31-.17,5.55-2.5,10.76-4.36,15.98-1.3,3.64-2.36,7.54-2.33,11.36-.29.42-.55.86-.86,1.27-2.58,3.38-6.2,6.17-10.4,6.85,1.6-4.94,3.2-9.88,4.8-14.81.57-1.76.78-4.17-.25-5.4.33-.68.54-1.39.51-2.16-.05-1.36-.83-2.57-1.4-3.8-2.21-4.77-1.46-10.31-.93-15.54.66-6.45.92-13.1-.98-19.31-1.89-6.21-6.27-11.96-12.42-14.02.53.57,1.05,1.14,1.58,1.7l-2.09-1.52c1.29,2.69,2.59,5.38,3.88,8.07-.48.68-.95,1.36-1.43,2.04,2.13-1.12,4.87.5,5.85,2.71.98,2.2.71,4.73.48,7.13-1.26,13.39-.58,26.94,1.95,40.15-.24,3.08-.78,6.2-2.38,8.83-1.73,2.84-4.99,4.97-8.28,4.49.73-3.18-.5-6.94-3.19-8.82-3.34,4.63-1.37,11.83-.86,17.11.77,8,2.05,15.94,3.84,23.77.51-6.79,1.94-13.51,4.22-19.93,1.8,6.54,3.6,13.07,5.4,19.61.06-1.83.13-3.74,1.02-5.34s2.86-2.76,4.57-2.12c1.4.53,2.16,2.02,2.74,3.4,4.68,11.24,5.86,23.9,3.33,35.81,2.22,1.23,5.16-.26,6.4-2.48,1.23-2.22,1.22-4.9,1.18-7.44-.39-22.08-.77-44.16-1.16-66.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M486.67,490.52c-1.06,1.86,3.28,9.24,3.99,11,3.65,8.91,7.3,17.81,10.94,26.72-1.21-11.73-4.07-23.28-8.48-34.22-.74-1.85-4.35-7.19-6.45-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M492.33,443.31c-.62.94-1.51,2.1-2.59,1.77-1.01-.31-1.18-1.64-1.16-2.69.1-6.2.2-12.39.3-18.59-5,3.58-4.36,8.28-4.71,13.63-.2,3.1.69,17.87-1.42,19.68,4.95-4.22,9.14-9.32,12.32-14.99-.87-.72-2.12.24-2.74,1.18Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M445.1,516.88c.2-.36.37-.74.54-1.11-.35.27-.58.63-.54,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M450.02,491.24c-.33-4.08.26-8.18.09-12.27-.17-4.09-1.24-8.39-4.22-11.2-4.27-4.03-15.97-1.97-12.04,5.67,1.09,2.12,3.89,3.22,6.07,2.26s3.25-3.92,2.06-5.98c4.73,7.17,4.31,17.35-1,24.11,6.07,5.26,7.99,14.66,4.67,21.93.71-.54,1.95-.61,2.72-.03,1.16.87,1.55,2.4,2.11,3.74.56,1.34,1.66,2.73,3.11,2.63,1.99-4.87,1.33-10.42.04-15.52-1.29-5.1-3.19-10.1-3.61-15.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M492.84,414.48c-2.28-1.75-4.98-2.93-7.83-3.3l7.83,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M512.3,466.27c-.63-2.81-1.93-5.43-2.7-8.21-1.81-6.47-.67-13.39-1.5-20.06-1.07-8.62-5.57-16.77-12.3-22.27l-2.96-1.25c2.84,2.18,5.01,5.22,5.97,8.67,2.29,7.9,3.01,16.16,4.03,24.33,1.57,12.59,3.87,25.1,6.88,37.43,1.97-6.04,3.97-12.43,2.59-18.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M480.79,436.84c2.05-1.62,3.15-4.21,3.5-6.8.31-2.32.09-4.66-.19-6.99-.2,1-1.49,1.83-2.6,1.57-1.41-.33-2.34-1.64-3.13-2.85-.2.69-.4,1.39-.6,2.08-.08-.38-.16-.75-.24-1.13l-.79,1c1.17,3.32,2.3,7.18.49,10.2-.88,1.46-2.32,2.48-3.73,3.45,2.14,1.49,5.24,1.08,7.29-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M484,422.23c.03.27.06.55.1.82.05-.27.04-.55-.1-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M475.35,455.72c-5.8-11.4-11.61-22.81-17.99-33.9-3.73-6.48-7.68-12.89-12.66-18.48-2.2-2.48-8.54-8.21-12.03-4.43-2.33,2.52.73,7.1-2.13,9.82.66.04,3.89-.31,4.23.11,7.27,8.98,11.27,20.55,11.11,32.1,2.34-1.83,5.53.71,7.36,3.05,11.21,14.41,21.7,29.39,31.4,44.86-1.88-6.84-1.92-14.09-3.95-20.89-1.28-4.27-3.31-8.28-5.34-12.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M542.78,483.51c2.77-7.42,4.94-15.03,5.19-22.91.22-7.16-1.41-14.6-5.2-20.73-.96-1.55-4.93-7.89-7.11-7.38-3.89.92,1.22,7.67,2.11,9.36,3.36,6.37,6.8,13.11,6.59,20.31-.17,5.55-2.5,10.76-4.36,15.98-1.3,3.64-2.36,7.54-2.33,11.36-.29.42-.55.86-.86,1.27-2.58,3.38-6.2,6.17-10.4,6.85,1.6-4.94,3.2-9.88,4.8-14.81.57-1.76.78-4.17-.25-5.4.33-.68.54-1.39.51-2.16-.05-1.36-.83-2.57-1.4-3.8-2.21-4.77-1.46-10.31-.93-15.54.66-6.45.92-13.1-.98-19.31-1.89-6.21-6.27-11.96-12.42-14.02.53.57,1.05,1.14,1.58,1.7l-2.09-1.52c1.29,2.69,2.59,5.38,3.88,8.07-.48.68-.95,1.36-1.43,2.04,2.13-1.12,4.87.5,5.85,2.71.98,2.2.71,4.73.48,7.13-1.26,13.39-.58,26.94,1.95,40.15-.24,3.08-.78,6.2-2.38,8.83-1.73,2.84-4.99,4.97-8.28,4.49.73-3.18-.5-6.94-3.19-8.82-3.34,4.63-1.37,11.83-.86,17.11.77,8,2.05,15.94,3.84,23.77.51-6.79,1.94-13.51,4.22-19.93,1.8,6.54,3.6,13.07,5.4,19.61.06-1.83.13-3.74,1.02-5.34s2.86-2.76,4.57-2.12c1.4.53,2.16,2.02,2.74,3.4,4.68,11.24,5.86,23.9,3.33,35.81,2.22,1.23,5.16-.26,6.4-2.48,1.23-2.22,1.22-4.9,1.18-7.44-.39-22.08-.77-44.16-1.16-66.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M486.67,490.52c-1.06,1.86,3.28,9.24,3.99,11,3.65,8.91,7.3,17.81,10.94,26.72-1.21-11.73-4.07-23.28-8.48-34.22-.74-1.85-4.35-7.19-6.45-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M492.33,443.31c-.62.94-1.51,2.1-2.59,1.77-1.01-.31-1.18-1.64-1.16-2.69.1-6.2.2-12.39.3-18.59-5,3.58-4.36,8.28-4.71,13.63-.2,3.1.69,17.87-1.42,19.68,4.95-4.22,9.14-9.32,12.32-14.99-.87-.72-2.12.24-2.74,1.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M505,423.04c2.92,10.79,4.44,21.96,4.52,33.14.01,1.87-.01,3.78.59,5.56.6,1.77,1.96,3.41,3.8,3.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M528.41,433.91c4.91,10.36-.12,33.51.26,35.14.37,1.63,1.3,3.21,2.79,3.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M485.74,421.62c-.58,3.29-1.06,7.11-1.64,10.41-3.85-3.27-6.3-8.14-6.64-13.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M454.03,509.94c-1.19.52-2.38,1.05-3.57,1.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M454.95,512.8c-.58,2.75-.6,5.62-.04,8.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M475.86,481.87c1.32,2.38,2.64,4.76,3.96,7.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M483.47,455.77c1.31-1.85,2.63-3.71,3.94-5.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M538.88,481.87c-.4,1.45-.79,2.91-1.19,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M529.24,469.94c1.16-3.71,2.32-7.42,3.48-11.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M540.89,450.22c2.04-1.19,5.01-.26,6.02,1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M517.1,431.22c2.73-.8,5.86-.08,7.98,1.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M443.38,442.26c2.54-2.83,6.5-4.32,10.27-3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.45,411.04c2.37-1.73,5.45-2.45,8.34-1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M431.52,485.1c-1.92,1.52-3.57,3.38-4.85,5.46l4.85-5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M433.11,477.59c2.62-1.87,6.79,2.31,9.19.18.96-.85,1.03-2.32.81-3.59-.22-1.26-.67-2.53-.48-3.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M506.91,466.11c3.18,6.53,3.84,14.24,1.82,21.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M526.14,476.32c.52,3.1-.08,6.38-1.66,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M499.49,635.97l-17.23-54.19c-4.7-4.81-10.45-9.45-16.53-14.35-14.89-12.01-30.29-24.42-32.16-41.11-2.09-18.6-4.6-24.86-6.26-29-.95-2.37-1.64-4.09-1.64-6.98,0-.26.08-.41.44-1.16.69-1.41,2.31-4.73,4.17-10.34.65-1.93,1.04-4.71,1.39-7.17.08-.57.16-1.12.24-1.66.53-3.54,3.7-6.12,7.24-5.86,2.31.15,4.59,1.04,6.25,2.44,2.92,2.47,4.76,6.38,5.2,11.01.4,4.03-.24,8.1-.83,11.72,2.63,5.05,4.29,10.96,5.53,16.51.36-1.59.7-3.18,1.03-4.73.59-2.75,1.19-5.59,1.9-8.39l.08-.33.19-.12c.03-.08.05-.18.09-.27-1.07-2.02-1.37-3.24-1.76-4.76-.54-2.14-1.21-4.79-4.46-11.29-1.91-3.83-3.9-7.71-5.83-11.47-7.87-15.35-16-31.21-22.66-50.86-.72-2.09-.87-5.45-.33-7.49.82-3.08,2.7-5.12,5.3-5.73,2.99-.71,6.67.61,8.96,3.2.89.98,1.67,2.18,2.36,3.67,3.75,8.16,11.71,21.29,17.75,29.27l19.24,25.47c1.9-1.84,5.31-5.37,5.85-6.95l.06-.16c.42-1.86.27-10.79.02-17.83-.81.88-2,1.65-3.63,1.65-.43,0-.99.07-1.63.15-2.48.31-6.24.78-9.31-2.25-3.09-3.04-3.57-8.01-1.13-11.82l7.52-11.67c.23-.23,5.62-5.5,13.55-2.58,6.86,2.54,13.59,7.86,15.03,9.04,1.51-.13,7.38-.47,12.73,1.67,5.48,2.2,11.31,8.47,12.59,9.9,1.51.02,7.06.24,9.98,2.07,1.3.81,12.53,16.44,9.61,29.35-.97,4.3-1.59,9.72-2.09,14.08-.38,3.27-.68,5.87-1.02,7.23l-.19,72.94,13.69,48.4-1.59.45-13.76-48.62v-.12s.2-73.27.2-73.27l.03-.1c.32-1.2.64-3.93,1-7.09.51-4.4,1.14-9.87,2.12-14.25,2.75-12.13-7.95-26.76-8.93-27.62-2.87-1.79-9.35-1.79-9.42-1.78h-.38s-.25-.28-.25-.28c-.06-.07-6.51-7.44-12.21-9.73-5.66-2.26-12.21-1.53-12.28-1.52l-.36.04-.27-.23c-.07-.06-7.51-6.28-14.81-8.98-6.54-2.4-11.19,1.62-11.75,2.15l-7.35,11.45c-2.02,3.16-1.65,7.26.89,9.75,2.5,2.47,5.52,2.09,7.95,1.78.7-.09,1.3-.16,1.83-.16,2.52,0,3.53-2.89,3.57-3.01l1.43-4.21.19,4.44c.08,1.92.76,18.85-.04,21.3l-.09.21c-1.05,2.56-6.27,7.5-6.88,8.07l-.67.63-20.36-26.95c-6.1-8.06-14.14-21.32-17.93-29.57-.62-1.33-1.3-2.4-2.09-3.26-1.91-2.16-4.93-3.27-7.35-2.7-2.01.47-3.42,2.05-4.08,4.55-.46,1.74-.32,4.73.3,6.53,6.62,19.54,14.73,35.35,22.57,50.64,1.93,3.76,3.92,7.64,5.83,11.48,3.33,6.66,4.03,9.41,4.59,11.63.4,1.57.69,2.71,1.85,4.81l.36.66-.54.37c-.06.21-.15.47-.34.69-.67,2.69-1.25,5.43-1.82,8.08-.58,2.74-1.19,5.58-1.89,8.37l-.89,3.54-.72-3.58c-1.31-6.47-3.07-13.9-6.26-19.93l-.13-.25.04-.27c.59-3.58,1.25-7.64.86-11.56-.4-4.2-2.04-7.71-4.62-9.9-1.39-1.17-3.33-1.92-5.29-2.06-2.67-.2-5.08,1.76-5.48,4.45-.08.53-.16,1.08-.24,1.65-.38,2.65-.77,5.38-1.46,7.46-1.89,5.72-3.55,9.1-4.25,10.55-.13.26-.22.45-.27.57.02,2.49.59,3.91,1.52,6.23,1.59,3.97,4.26,10.6,6.37,29.43,1.79,16.01,16.92,28.21,31.55,40.01,6.18,4.99,12.03,9.69,16.82,14.63l.14.14.06.19,17.29,54.37-1.58.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M513.74,466.33c-1.95-.39-3.65-2.05-4.42-4.33-.61-1.81-.62-3.7-.63-5.52v-.29c-.07-11.12-1.58-22.2-4.49-32.93l1.6-.43c2.94,10.87,4.47,22.09,4.54,33.35v.29c.01,1.7.02,3.45.55,5,.46,1.35,1.53,2.9,3.18,3.24l-.33,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M531.08,473.77c-1.57-.8-2.75-2.46-3.22-4.53-.11-.5.02-1.56.42-4.54.99-7.37,3.04-22.71-.61-30.43l1.5-.71c3.87,8.16,1.77,23.83.76,31.36-.25,1.86-.48,3.62-.44,3.97.36,1.57,1.22,2.82,2.36,3.4l-.75,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M484.67,433.6l-1.1-.94c-4.04-3.44-6.57-8.46-6.93-13.75l1.65-.11c.29,4.29,2.22,8.51,5.25,11.58.19-1.2.38-2.45.56-3.67.26-1.75.53-3.57.82-5.23l1.63.29c-.29,1.64-.56,3.44-.82,5.18-.26,1.75-.53,3.57-.82,5.22l-.25,1.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 450.29,
    y: 509.9,
    width: 3.9,
    height: 1.66,
    transform: "translate(-167.63 225.91) rotate(-23.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M454.1,521.34c-.58-2.85-.56-5.86.04-8.71l1.62.34c-.56,2.63-.57,5.41-.04,8.04l-1.62.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 477.01,
    y: 481.36,
    width: 1.66,
    height: 8.16,
    transform: "translate(-175.63 293.2) rotate(-29.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 482.03,
    y: 452.16,
    width: 6.82,
    height: 1.66,
    transform: "translate(-164.71 587.7) rotate(-54.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 536.02,
    y: 483.22,
    width: 4.52,
    height: 1.66,
    transform: "translate(-70.3 876.07) rotate(-74.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 525.16,
    y: 463.55,
    width: 11.66,
    height: 1.66,
    transform: "translate(-70.92 832.22) rotate(-72.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M546.17,452.45c-.38-.81-1.16-1.45-2.12-1.75-.97-.3-1.96-.22-2.74.23l-.83-1.43c1.17-.68,2.66-.82,4.06-.38,1.41.44,2.55,1.39,3.13,2.62l-1.5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M524.52,433.66c-1.91-1.72-4.73-2.36-7.19-1.65l-.46-1.59c3-.87,6.44-.09,8.76,2l-1.11,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M444,442.81l-1.23-1.11c2.73-3.03,6.94-4.62,10.98-4.14l-.2,1.64c-3.52-.42-7.19.96-9.56,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M428.94,411.7l-.98-1.34c2.57-1.88,5.83-2.64,8.97-2.1l-.28,1.63c-2.66-.46-5.53.21-7.71,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M427.37,491l-1.41-.87c1.34-2.18,3.04-4.08,5.04-5.67l1.03,1.3c-1.85,1.47-3.42,3.23-4.66,5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M440.57,479.22c-1.04,0-2.12-.35-3.12-.68-1.49-.49-2.9-.95-3.85-.27l-.96-1.35c1.63-1.16,3.59-.52,5.33.05,1.82.6,2.99.91,3.8.19.78-.69.67-2.07.54-2.82-.05-.31-.12-.63-.19-.94-.22-1-.45-2.02-.29-3.12l1.64.24c-.12.79.07,1.63.27,2.51.07.34.15.68.21,1.01.33,1.89-.05,3.44-1.07,4.35-.69.62-1.47.83-2.29.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M509.53,487.55l-1.59-.46c1.96-6.77,1.32-14.28-1.77-20.62l1.49-.72c3.26,6.7,3.94,14.65,1.87,21.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.19,485.83l-1.43-.83c1.48-2.54,2.05-5.65,1.56-8.54l1.63-.28c.55,3.27-.09,6.79-1.76,9.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M366.11,501.16c.15,1.14.1,2.32-.15,3.44-1.08,4.98-4.19,19.5-5.33,27.44-1.36,9.7-17.03,39.72-17.03,39.72,0,0-14.43,17.94-21.78,27.28-3.61,4.58-9.32,23.14-14.17,40.82-6.12-1.85-12.18-3.86-18.21-5.99-4.98-1.77-9.96-3.64-14.88-5.58-6.92-2.73-15.74-7.07-25.87-12.61,2.75-9.98,4.58-17.66,4.55-18.11-.08-1.04,5.89-12.55,5.89-12.55l-5.21-68.59-3.08-10.44c-1.61-5.4-2.62-10.96-3.03-16.52-.65-8.49.07-17.05,2.14-25.37l8.99-13.34,4.2-.31,13.01-18.17s7.03-2.12,8.84,3.18c1.8,5.31-5.86,15.19-5.86,15.19l-2.63,16.34,6.26,15.29,3.24,1.19s1.09-26.93.35-32.31l6.92-24.58s4.12-8.21,5.4-12.35c1.26-4.12,8.66-8.21,12.91-.98,0,0,2.37,3.67.66,8.72-1.74,5.05-3.18,9.02-3.18,9.02,0,0-1.57,20.82-2.07,21.4-.5.55,3.06,31,3.06,31l2.71,1.21.96-29.05,5.64-27.29s-.46-13.13,8.79-11.54c0,0,4.34-.5,6.8,4.24,2.47,4.72.12,36.13.12,36.13l2.28,32.47,3.66,25.04,4.3-17.16s.25-24.6,15.77-26.7c0,0,4.62-.83,5.56,2.38.94,3.19-2.3,9.77-1.84,16.06.35,4.42.98,9.4,1.29,11.97Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M361.39,470.76c-.71-3.28-5.37-2.8-5.37-2.8-15.64.92-17.75,25.43-17.75,25.43l-5.6,16.79-1.75-25.26.18-32.55s4.73-31.15,2.62-36.04c-2.09-4.91-6.46-4.73-6.46-4.73-9.1-2.28-9.63,10.84-9.63,10.84l-7.69,26.78-3.15,28.89-2.62-1.4s-1.24-30.64-.71-31.15c.53-.53,3.68-21.18,3.68-21.18,0,0,1.74-3.84,3.84-8.75,2.09-4.91,0-8.75,0-8.75-3.68-7.53-11.37-4.02-12.95,0-1.58,4.02-6.31,11.9-6.31,11.9l-8.77,23.98c.34,5.42-2.78,32.2-2.78,32.2l-3.15-1.43-5.08-15.73,3.86-16.1s8.4-9.26,7-14.7c-1.4-5.42-8.57-3.84-8.57-3.84l-14.35,17.14h-4.22l-9.97,12.61c-2.69,8.15-4.06,16.63-4.06,25.15,0,5.58.58,11.19,1.77,16.7l2.28,10.64v68.79s-6.82,11.02-6.82,12.06c0,.48-2.82,9.17-6.75,20.01,17.16,10.1,31.95,17.91,42.42,22.03,4.92,1.95,9.9,3.81,14.9,5.58,6.29-17.66,13.64-36.56,17.69-40.97,8.04-8.75,23.79-25.56,23.79-25.56,0,0,17.91-28.75,20-38.31,1.74-7.85,5.93-22.09,7.39-26.97.34-1.1.48-2.27.41-3.42-.12-2.59-.37-7.6-.37-12.03,0-6.31,3.74-12.61,3.05-15.87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M253.98,463.83c2.67-3.33,8.17-4.61,11.28-1.68,1.78,1.68,2.38,4.24,2.84,6.64.45,2.41.9,4.96,2.5,6.82,1.6,1.86,4.78,2.59,6.46.8.22,3.62.44,7.25.67,10.87,3.87-6.71,5.86-14.49,5.7-22.24-.08-3.76-.65-7.59.23-11.25.87-3.66,3.72-7.23,7.48-7.4,4.17-.19,7.47,3.87,8.27,7.97.8,4.1-.14,8.31-.39,12.48-.39,6.36.86,12.81,3.58,18.56.88-1.77,1.75-3.55,2.63-5.32.79,3.56,1.58,7.12,2.37,10.68.68-7.84,1.37-15.68,2.05-23.51.19-2.21.41-4.49,1.44-6.46,1.03-1.97,3.1-3.57,5.31-3.35,2.98.3,4.7,3.48,5.7,6.3,7.46,21.09,4.39,44.26,1.22,66.4,2.07.37,3.82-1.71,4.33-3.75.52-2.04.33-4.25,1.11-6.2.77-1.96,3.17-3.57,4.95-2.45,2.61,1.64.79,6.73,3.53,8.13.85-6.55,3.46-12.86,7.49-18.1,1.83-2.38,4.59-4.75,7.5-3.99,2.17.56,3.59,2.78,3.91,5.01.32,2.22,3.53-6.95,2.97-4.78,1.25-12.77-1.26-14.11,0-26.88.23-2.31,3.95-6.3,2.37-7.99-1.51-1.61-6.01-3.96-8.01-3.03-2,.92-8.5,4.16-9.8,5.94-8.13,11.23-7.58,27.49-10.11,41.12-2.16-20.79-4.31-41.92-.5-62.47,2.1-11.34,5.98-23.14,2.32-34.08-1.67-4.99-6.1-9.98-11.28-9.03-4.18.77-6.7,4.98-8.4,8.87-5.7,13.08-8.23,27.28-10.72,41.32,3.11-14.14,6.22-28.27,9.33-42.41.81-3.67,1.62-7.46.95-11.17-.67-3.7-3.2-7.33-6.88-8.11-3.65-.77-7.28,1.39-10.03,3.91-9.84,9-13.5,22.73-16.71,35.68,1.13-3.38,2.27-6.89,1.92-10.43-.35-3.55-2.6-7.17-6.08-7.93-4.51-.99-8.6,3.04-10.58,7.2-1.98,4.17-2.96,8.96-6.11,12.33-2.3-2.59-6.62-2.44-9.51-.53-2.89,1.91-4.63,5.11-6.04,8.28-5.18,11.62-7.4,24.53-6.4,37.21,2.28-5.09,8.05-8.37,13.59-7.74-.33-2.82-.66-5.64-.99-8.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M264.87,490.76c-.14,2.09-.28,4.18-.42,6.27.64-1.74,3.19-2.39,4.59-1.16-.31-1.33.52-2.61,1.04-3.87.53-1.26.58-3.04-.64-3.64-1.46-.71-2.89.96-3.66,2.39-.06-.52-.13-1.04-.19-1.55l-.71,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M288.62,487.02c-1.71,1.95-2.87,4.37-3.34,6.92.72-.71,1.47-1.43,2.42-1.77.95-.34,2.15-.2,2.75.61.37.5.51,1.23,1.06,1.52.56.29,1.28-.06,1.62-.6.33-.54.38-1.2.42-1.83.07-1.2.15-2.44-.2-3.6-.35-1.16-1.21-2.24-2.39-2.49-1.18-.25-2.58.61-2.59,1.82l.25-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M311.6,492.73c-1.81,2.44-3.02,5.33-3.47,8.33,1.22-.18,2.24-.97,3.22-1.73.97-.75,2.03-1.52,3.26-1.61s2.61.79,2.57,2.02c-.23-1.39-.01-2.81.14-4.21s.21-2.86-.31-4.17c-.52-1.31-1.78-2.42-3.19-2.34s-2.61,1.72-1.96,2.96l-.26.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M248.36,501.03c-1.27,2.38-1.94,5.09-1.93,7.79.02-1.24,1.19-2.25,2.42-2.43,1.23-.18,2.47.3,3.54.94.25-1.25.49-2.54.23-3.79s-1.17-2.45-2.43-2.66-2.65,1.01-2.31,2.24c-.13-.32-.26-.64-.39-.95l.87-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M264.87,490.76c-.14,2.09-.28,4.18-.42,6.27.64-1.74,3.19-2.39,4.59-1.16-.31-1.33.52-2.61,1.04-3.87.53-1.26.58-3.04-.64-3.64-1.46-.71-2.89.96-3.66,2.39-.06-.52-.13-1.04-.19-1.55l-.71,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M288.62,487.02c-1.71,1.95-2.87,4.37-3.34,6.92.72-.71,1.47-1.43,2.42-1.77.95-.34,2.15-.2,2.75.61.37.5.51,1.23,1.06,1.52.56.29,1.28-.06,1.62-.6.33-.54.38-1.2.42-1.83.07-1.2.15-2.44-.2-3.6-.35-1.16-1.21-2.24-2.39-2.49-1.18-.25-2.58.61-2.59,1.82l.25-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M311.6,492.73c-1.81,2.44-3.02,5.33-3.47,8.33,1.22-.18,2.24-.97,3.22-1.73.97-.75,2.03-1.52,3.26-1.61s2.61.79,2.57,2.02c-.23-1.39-.01-2.81.14-4.21s.21-2.86-.31-4.17c-.52-1.31-1.78-2.42-3.19-2.34s-2.61,1.72-1.96,2.96l-.26.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M248.36,501.03c-1.27,2.38-1.94,5.09-1.93,7.79.02-1.24,1.19-2.25,2.42-2.43,1.23-.18,2.47.3,3.54.94.25-1.25.49-2.54.23-3.79s-1.17-2.45-2.43-2.66-2.65,1.01-2.31,2.24c-.13-.32-.26-.64-.39-.95l.87-1.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M290.23,634.16l-1.56-.56c8.41-23.63,14.42-37.51,17.86-41.25,7.71-8.39,22.7-24.39,23.74-25.5.97-1.57,17.86-28.89,19.85-37.98,1.6-7.22,5.32-20.04,7.4-27.03.31-1.01.44-2.09.37-3.13v-.27c-.14-2.62-.37-7.5-.37-11.81,0-3.38,1.01-6.68,1.9-9.6.78-2.54,1.45-4.73,1.16-6.1-.54-2.5-4.44-2.15-4.47-2.15-14.77.87-16.98,24.44-17,24.68l-.04.19-6.92,20.75-2.04-29.42.18-32.73c1.31-8.6,4.33-31.76,2.68-35.59-1.83-4.29-5.53-4.24-5.68-4.23h-.12s-.12-.02-.12-.02c-1.95-.49-3.54-.25-4.85.74-3.43,2.56-3.75,9.27-3.75,9.33l-.03.19-7.67,26.71-3.28,30.03-4.12-2.2-.02-.47c-1.09-27.07-.88-30.85-.59-31.59h0c.44-1.04,2.43-13.37,3.58-20.91l.06-.22s1.76-3.89,3.84-8.74c1.91-4.48.05-7.99.03-8.03-1.68-3.43-4-4.05-5.65-3.99-2.72.11-5.08,2.07-5.8,3.9-1.52,3.88-5.83,11.12-6.33,11.96l-8.68,23.75c.27,5.79-2.67,31.08-2.79,32.17l-.13,1.13-4.52-2.06-5.27-16.3,3.96-16.53.14-.16c2.25-2.49,7.86-9.84,6.81-13.94-1.06-4.09-6.08-3.5-7.33-3.29l-14.4,17.21h-4.2l-9.63,12.18c-2.63,8.02-3.97,16.35-3.97,24.75,0,5.57.59,11.13,1.75,16.53l2.3,10.82v69.03l-.12.2c-3.15,5.09-6.52,10.87-6.7,11.7,0,.71-3.36,10.76-6.79,20.22l-1.56-.56c3.94-10.85,6.59-19.09,6.7-19.81,0-.97,3.67-7.14,6.81-12.22v-68.47l-2.27-10.56c-1.19-5.51-1.79-11.19-1.79-16.88,0-8.63,1.38-17.18,4.1-25.41l.05-.14,10.31-13.04h4.23l14.28-17.06.28-.06c2.75-.61,8.29-.45,9.55,4.44,1.4,5.46-5.88,13.99-7.04,15.3l-3.76,15.67,4.9,15.16,1.79.81c.58-5.14,2.94-26.27,2.65-30.92v-.17s8.88-24.29,8.88-24.29c.05-.08,4.71-7.87,6.24-11.78,1.06-2.69,4.18-4.82,7.27-4.95,1.78-.08,5.03.47,7.19,4.88.08.14,2.24,4.22.02,9.44-1.9,4.42-3.51,8.01-3.8,8.66-3.18,20.81-3.67,21.3-3.9,21.53.15-.14.18-.3.19-.31-.29,1.34.29,19.13.75,30.37l1.12.6,3.05-27.81,7.66-26.69c.05-.95.56-7.61,4.41-10.49,1.69-1.27,3.76-1.62,6.15-1.04.81,0,5.02.29,7.13,5.23,2.12,4.93-2.03,32.94-2.56,36.43l-.18,32.49,1.46,21.03,4.25-12.74c.08-.85.7-6.58,3.05-12.51,3.38-8.49,8.72-13.19,15.46-13.58,1.83-.19,5.54.29,6.22,3.45.38,1.79-.35,4.17-1.2,6.93-.86,2.8-1.83,5.98-1.83,9.11,0,4.26.23,9.12.36,11.73v.26c.09,1.23-.07,2.51-.43,3.7-2.07,6.97-5.78,19.74-7.37,26.91-2.1,9.59-19.37,37.39-20.1,38.57l-.1.13c-.16.17-15.83,16.9-23.78,25.55-3.24,3.53-9.3,17.59-17.52,40.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M279.9,477.55c.92,3.26-.01,6.98-2.35,9.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M278.14,487.55l-1.2-1.14c2.15-2.25,3-5.64,2.15-8.63l1.59-.45c1,3.55,0,7.56-2.55,10.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M253.21,500.69c2.28-3.52,4.49-8.36,3.88-12.51-1.2-8.12-4.9-17.48-3.23-25.52,1.06-5.14,2.13-10.27,3.19-15.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M253.9,501.14l-1.39-.9c1.68-2.59,4.39-7.59,3.75-11.94-.36-2.45-.94-4.97-1.56-7.64-1.41-6.1-2.86-12.4-1.67-18.17l3.19-15.41,1.62.34-3.19,15.41c-1.12,5.41.29,11.54,1.66,17.46.62,2.71,1.21,5.26,1.58,7.77.72,4.88-2.2,10.29-4,13.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M328.24,425.01l-1-.27c-2.56-.69-5.27-.7-7.83-.02l-.42-1.6c2.51-.66,5.14-.73,7.68-.21l.05-1.3,1.65.07-.14,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M300.56,415.38c-1.27,0-2.54-.38-3.58-1.12l.96-1.34c1.34.96,3.22,1.09,4.68.32,1.46-.77,2.41-2.4,2.37-4.04l1.65-.04c.06,2.26-1.25,4.49-3.25,5.55-.87.46-1.85.69-2.83.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M353.51,483.52l-4.59-1.37-.05-.56c-.48-5.12,3.22-10.22,8.24-11.37l.37,1.61c-3.99.91-7.08,4.98-6.99,9.05l3.5,1.04-.47,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M304.02,473.06c.18,2.78-.16,9.42.03,12.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M303.22,485.31c-.09-1.42-.05-3.83-.02-6.16.04-2.3.08-4.67-.01-6.03l1.65-.11c.09,1.42.05,3.83.02,6.16-.04,2.3-.08,4.67.01,6.03l-1.65.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M307.07,476.91c-.33,4.55-.67,9.1-1,13.65.03-.58.05-1.16.08-1.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "306.89 490.61 305.24 490.51 305.32 488.78 305.36 488.78 306.24 476.85 307.89 476.97 306.89 490.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M332.32,515.27c1.21,4.98.66,10.37-1.55,14.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M331.52,530.62l-1.49-.71c2.14-4.48,2.67-9.61,1.49-14.44l1.61-.39c1.27,5.2.7,10.72-1.6,15.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M289.09,510.45c-2.77-5.68-3.09-15.48.66-19.59l1.22,1.12c-3.27,3.59-2.89,12.64-.4,17.75l-1.49.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M313.25,510.61l-1.28-1.05c2.81-3.42,4.31-7.54,4.23-11.6l1.65-.04c.09,4.45-1.54,8.96-4.6,12.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M265.85,505.29c-2.27-3.54-3.22-7.95-2.59-12.11l1.64.25c-.57,3.77.29,7.76,2.35,10.97l-1.39.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M250.6,514.98c-1.93-2.71-2.89-6.04-2.7-9.37l1.65.09c-.17,2.95.69,5.9,2.4,8.31l-1.35.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M275.66,431.53l-.67-.65c-1.25-1.21-3.29-1.53-4.86-.78l-.72-1.49c1.92-.93,4.27-.71,6.01.49l1.53-2.02,1.32,1-2.61,3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M294.86,443.5c-1.76-2.23-5.26-2.82-7.66-1.3l-.89-1.4c3.08-1.96,7.59-1.19,9.84,1.67l-1.3,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M322.32,450.72c-2.65-1.34-5.98-1.41-8.69-.18l-.68-1.51c3.2-1.45,6.98-1.37,10.12.21l-.75,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M254.98,464.08l-1.43-.83c1.88-3.24,5.78-5.18,9.49-4.71l-.21,1.64c-3.07-.39-6.3,1.22-7.86,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M243.99,479.52l-1.65-.03c.05-2.53,2.13-4.87,4.64-5.21l.22,1.64c-1.7.23-3.17,1.88-3.21,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M669.64,361.38c-38.28,0-69.43-31.15-69.43-69.43s31.15-69.43,69.43-69.43,69.43,31.15,69.43,69.43-31.15,69.43-69.43,69.43ZM669.64,224.18c-37.37,0-67.77,30.4-67.77,67.77s30.4,67.77,67.77,67.77,67.77-30.4,67.77-67.77-30.4-67.77-67.77-67.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M747.31,293.75c-14.63,23.99-19.83,20.75-69.72,44.65-25.33,12.13-49.81-26.87-33.25-66.91.81-1.95,7.96-11.83,7.96-11.83,3.01-13.24,14-24.33,27.23-27.44,13.21-3.13,28.01,1.85,36.63,12.35,9.37-8.29,22.96-11.37,35.06-8.38.58,1.69,1.13,3.34,1.66,4.97.2.63.41,1.24.6,1.87.63,1.94,1.22,3.87,1.77,5.83,1.09,3.71,2.1,7.43,3.05,11.19-5.51-1.54-11.06-1.57-16.29.98-3.66,1.79-6.72,4.73-10.53,6.19-3.81,1.44-9.07.63-10.53-3.18,1.84,7.65,9.86,5.36,17.57,6.87,11.93,2.34,14.95,12.75,8.8,22.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M724.78,281.92s12.28-1.66,18.12-.79c3.7.55,5.98,2.71,7.06,4.05.5.62.79,1.39.85,2.19l.66,9.6c.08,1.1-.3,2.18-1.06,2.98-2.39,2.49-9.63,7.04-31.04,8.68-30.11,2.3,5.41-26.7,5.41-26.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M716.18,309.59c-5.31,0-8.4-1.25-9.41-3.79-1.32-3.29,1.28-8.45,7.71-15.34,4.65-4.98,9.73-9.14,9.78-9.18.12-.1.26-.16.41-.18.51-.07,12.47-1.67,18.35-.79,4.02.6,6.48,2.98,7.58,4.35.61.75.96,1.67,1.03,2.65l.66,9.6c.09,1.34-.38,2.66-1.29,3.61-2.52,2.63-9.98,7.28-31.57,8.93-1.16.09-2.25.13-3.25.13ZM725.12,282.71c-5.58,4.59-18.96,17.13-16.82,22.47.88,2.19,4.68,3.1,11,2.62,21.04-1.61,28.15-5.97,30.51-8.43.59-.61.89-1.47.83-2.35l-.66-9.6c-.04-.64-.27-1.24-.67-1.73-.96-1.18-3.07-3.24-6.54-3.75-5.22-.78-15.94.54-17.65.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M715.81,257.11c3.46,4.3,10.05,14.05,10.05,29.18,0,11.44-13.25,50.5-47.16,55.26-35.9,5.03-64.76-25.69-58.6-62.66,4.26-25.57,66.88-57.59,95.7-21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M671.06,342.91c-14.15,0-27.45-5.49-37.32-15.63-12.24-12.56-17.5-30.25-14.46-48.54,2.35-14.12,22.33-30.35,44.54-36.16,21.71-5.69,40.89-.58,52.63,14.01h0c4.67,5.8,10.24,15.67,10.24,29.7,0,6.5-3.85,19.43-10.99,30.58-6.52,10.19-18.22,22.88-36.88,25.5-2.6.36-5.19.54-7.75.54ZM680.6,241.97c-5.21,0-10.69.73-16.36,2.21-21.63,5.67-41.07,21.29-43.32,34.83-2.96,17.76,2.14,34.93,14.01,47.11,11.29,11.58,27.2,16.9,43.66,14.6,34.33-4.81,46.45-44.68,46.45-54.44,0-13.55-5.37-23.07-9.87-28.66h0c-8.27-10.27-20.41-15.66-34.56-15.66Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 671.94,
    cy: 283.71,
    rx: 52.09,
    ry: 49.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 671.83,
    cy: 286.29,
    rx: 42.76,
    ry: 40.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M724.03,284.54c-.46,0-.83-.37-.83-.83,0-26.73-23-48.47-51.26-48.47s-51.26,21.75-51.26,48.47c0,.46-.37.83-.83.83s-.83-.37-.83-.83c0-27.64,23.74-50.13,52.92-50.13s52.92,22.49,52.92,50.13c0,.46-.37.83-.83.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M710.29,317.91c-.21,0-.42-.08-.58-.23-.33-.32-.33-.84-.02-1.17,8.71-8.96,13.51-20.61,13.51-32.79,0-.46.37-.83.83-.83s.83.37.83.83c0,12.62-4.96,24.67-13.98,33.95-.16.17-.38.25-.59.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M671.94,333.84c-13.94,0-27.1-5.09-37.05-14.34-.33-.31-.35-.83-.04-1.17.31-.33.84-.35,1.17-.04,9.64,8.96,22.4,13.9,35.92,13.9,8.29,0,16.52-1.91,23.81-5.53.41-.2.91-.04,1.11.37.2.41.04.91-.37,1.11-7.51,3.73-16,5.71-24.54,5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M630.1,313.91c-.25,0-.49-.11-.65-.32-.77-.97-1.5-1.99-2.2-3.02-.25-.38-.15-.89.23-1.15.38-.26.89-.15,1.15.23.67,1,1.38,1.98,2.12,2.92.28.36.22.88-.14,1.16-.15.12-.33.18-.51.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M624.82,305.57c-.3,0-.6-.17-.74-.46-3.35-6.72-5.05-13.92-5.05-21.4,0-.46.37-.83.83-.83s.83.37.83.83c0,7.23,1.64,14.18,4.88,20.66.2.41.04.91-.37,1.11-.12.06-.24.09-.37.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M748.38,297.2s-9.29-6.49-24.35-.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M748.38,298.03c-.16,0-.33-.05-.47-.15-.09-.06-9.15-6.15-23.58-.51-.42.17-.91-.04-1.07-.47-.17-.43.04-.91.47-1.07,15.3-5.98,24.73.42,25.13.7.37.26.47.78.21,1.15-.16.23-.42.35-.68.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M740.39,301.72c-3.55,1.05-9.51,2.27-19.26,3.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M721.12,305.57c-.43,0-.79-.33-.82-.76-.04-.46.31-.85.76-.89,10.06-.78,15.94-2.06,19.09-2.99.44-.13.9.12,1.03.56.13.44-.12.9-.56,1.03-4.7,1.39-11.24,2.42-19.43,3.06-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M745.22,299.67s-.56.49-2.32,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M742.89,301.69c-.33,0-.64-.2-.77-.52-.17-.42.04-.91.46-1.07,1.55-.62,2.08-1.05,2.09-1.06.35-.29.87-.25,1.16.1.29.34.26.85-.08,1.15-.11.1-.76.63-2.56,1.34-.1.04-.2.06-.31.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M753.47,243.02c-.18-.63-.4-1.24-.6-1.87-3.16-9.8-7.23-20.56-12.18-31.91-.91-2.1-1.87-4.24-2.83-6.39-.38.03-.74.07-1.11.1-4.75.48-9.75,1.08-13.66,3.77-3.92,2.75-6.24,8.39-3.71,12.45,2.48,4.02,8.99,6.26,7.96,10.84-10.61,5.98-23.55,5.28-35.35,8.29-7.1,1.8-13.82,5-19.71,9.3-.02,0-.02.02-.03.02-1.87,1.41-3.67,2.9-5.36,4.5-.74.71-1.52,1.49-2.18,2.35t-.02.03c-.98,1.24-1.72,2.63-1.87,4.2-.41,4.42,3.61,7.43,7.9,9.35.79.36.74,1.51-.07,1.79-2.8,1.13-5.53,2.43-7.73,4.47-.02,0-.03.02-.05.03-1.36,1.22-.25,3.53,1.61,3.28.2-.03.45-.05.66-.07,1.82-.13,3.53.08,5,.6,2.53.89,4.3,2.62,4.49,4.73.26,3.36-3.56,6.39-8.52,6.77-1.21.12-.28,1.56,1.49,1.85,3.53.63,7.12-.05,10.59-.86,4.15-.99,8.59-2.43,10.94-5.99.99-1.51,1.29-3.48.99-5.26-.41-2.45-1.95-4.58-4.4-4.83,7.68-.91,15.29-2.43,22.71-4.55h.02l2.33-.71c2.22-.66,4.55-1.47,6.41-2.8,1.16-.83,2.12-1.8,2.8-3.08,1.72-3.33-.71-8.59-4.39-7.9,10.68-4.19,21.96-6.64,32.76-10.49,1.72-.63,3.44-1.29,5.13-2.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M671.64,99.85c-10,8.89-21.42,16.44-32.94,23.24-60.27,35.65-128.34,57-197.6,67.42-69.24,10.41-139.76,10.1-209.55,4.35-13.7-1.13-27.64-2.52-40.24-8.04-10.68-4.7-20.36-12.88-24.89-23.45,15.11-17.21,29.16-34.63,44.81-51.06,3.72-3.92,7.53-7.78,11.45-11.57,3.31-3.16,6.67-6.27,10.16-9.32,3.99-3.51,8.09-6.94,12.4-10.25,5.88-4.57,12.07-8.95,18.69-13.14,1.62-1.04,3.23-2.05,4.85-3.05,165.04-102.57,286.51-69.09,367.55,0,6.11,5.18,12,10.59,17.64,16.19,3.44,3.33,6.77,6.77,10,10.25.36.36.7.74,1.04,1.14,2.27,2.42,4.47,4.85,6.62,7.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M678.15,83.39l-555.26,2.53,8.4-12.58c4.04-6.05,10.83-9.69,18.11-9.69h502.44c6.59,0,12.83,2.98,16.96,8.12l9.35,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M122.9,86.75c-.3,0-.58-.17-.73-.44-.15-.27-.13-.6.04-.85l8.4-12.58c4.2-6.3,11.23-10.05,18.8-10.05h502.44c6.88,0,13.29,3.07,17.6,8.43l9.35,11.62c.2.25.24.59.1.87s-.43.47-.74.47l-555.26,2.53h0ZM149.4,64.48c-7.01,0-13.53,3.48-17.42,9.32l-7.54,11.29,551.98-2.52-8.28-10.28c-4-4.96-9.94-7.81-16.31-7.81H149.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 323.25,
    y: 166.63,
    width: 143.48,
    height: 143.48,
    rx: 56.53,
    ry: 56.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M410.2,310.93h-30.42c-31.63,0-57.35-25.73-57.35-57.35v-30.42c0-31.63,25.73-57.35,57.35-57.35h30.42c31.63,0,57.35,25.73,57.35,57.35v30.42c0,31.63-25.73,57.35-57.35,57.35ZM379.78,167.45c-30.71,0-55.7,24.99-55.7,55.7v30.42c0,30.71,24.99,55.7,55.7,55.7h30.42c30.71,0,55.7-24.99,55.7-55.7v-30.42c0-30.71-24.99-55.7-55.7-55.7h-30.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M349.33,250.48v20.4c0,6.4,5.19,11.59,11.59,11.59h69.96c6.37,0,11.53-5.14,11.59-11.51.09-9.18.58-20.48.58-20.48h-93.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M430.88,283.29h-69.96c-6.85,0-12.42-5.57-12.42-12.42v-20.4c0-.46.37-.83.83-.83h93.71c.23,0,.44.09.6.26s.24.38.23.61c0,.11-.49,11.39-.58,20.45-.06,6.8-5.63,12.33-12.42,12.33ZM350.16,251.31v19.57c0,5.93,4.83,10.76,10.76,10.76h69.96c5.88,0,10.7-4.79,10.76-10.69.07-7.63.43-16.82.54-19.64h-92.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M605.39,257.3H196.22c-4.32,0-8.2-2.65-9.77-6.68l-63.11-161.97c-1.65-4.24,1.47-8.81,6.02-8.81h542.88c4.55,0,7.67,4.57,6.02,8.81l-63.11,161.97c-1.57,4.03-5.45,6.68-9.77,6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M605.39,258.12H196.22c-4.7,0-8.83-2.83-10.54-7.2l-63.11-161.97c-.87-2.24-.58-4.77.77-6.76,1.36-1.99,3.61-3.18,6.02-3.18h542.88c2.41,0,4.66,1.19,6.02,3.18s1.65,4.52.77,6.76l-63.11,161.97c-1.71,4.38-5.84,7.2-10.54,7.2ZM129.37,80.66c-1.89,0-3.59.9-4.65,2.46-1.07,1.56-1.28,3.46-.6,5.23l63.11,161.97c1.46,3.74,4.99,6.15,9,6.15h409.17c4.01,0,7.54-2.41,9-6.15l63.11-161.97c.69-1.76.47-3.67-.6-5.23-1.07-1.56-2.76-2.46-4.65-2.46H129.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "608.43 243.18 192.2 243.18 134.93 90.1 665.43 90.1 608.43 243.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 349.78,
    y: 257.08,
    width: 92.79,
    height: 6.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M547.63,236.6H253.71c-1.61,0-3.15-.73-3.44-1.64l-41.81-132.82c-.47-1.49.84-2.7,2.92-2.7h378.58c2.08,0,3.38,1.21,2.92,2.7l-41.81,132.82c-.29.91-1.83,1.64-3.44,1.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "546.54 233.59 254.79 233.59 219.26 116.89 582.07 116.89 546.54 233.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M296.67,145.86h-55.23c-1.36,0-2.26.74-2,1.64.26.9,1.56,1.63,2.92,1.63h54.91c1.36,0,2.32-.73,2.16-1.63-.16-.9-1.4-1.64-2.76-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M298.52,155.94h-46.97c-1.34,0-2.23.71-1.99,1.58.24.87,1.51,1.57,2.84,1.57h46.71c1.33,0,2.29-.7,2.13-1.57-.16-.87-1.37-1.58-2.71-1.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M300.3,165.68h-53.3c-1.32,0-2.19.69-1.95,1.53.24.84,1.49,1.52,2.8,1.52h53.01c1.31,0,2.25-.68,2.1-1.52-.15-.84-1.34-1.53-2.66-1.53Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M302.03,175.07h-31.31c-1.29,0-2.18.66-1.98,1.48.2.81,1.4,1.47,2.69,1.47h31.14c1.29,0,2.21-.66,2.07-1.47-.15-.81-1.31-1.48-2.61-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M303.69,184.15h-51.5c-1.27,0-2.12.64-1.9,1.43.22.78,1.43,1.42,2.69,1.42h51.22c1.26,0,2.18-.63,2.04-1.42-.14-.79-1.29-1.43-2.56-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M305.3,192.93h-41.59c-1.25,0-2.1.62-1.89,1.38.2.76,1.38,1.37,2.62,1.37h41.37c1.24,0,2.14-.61,2.01-1.37-.14-.76-1.26-1.38-2.51-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M306.86,201.42h-40.91c-1.23,0-2.07.6-1.87,1.34.2.73,1.35,1.33,2.57,1.33h40.7c1.22,0,2.11-.59,1.98-1.33-.13-.74-1.24-1.34-2.47-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M308.37,209.64h-44.64c-1.21,0-2.03.58-1.83,1.29.2.71,1.33,1.29,2.54,1.29h44.41c1.2,0,2.08-.58,1.95-1.29-.13-.71-1.21-1.29-2.42-1.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M309.83,217.6h-28.83c-1.19,0-2.02.56-1.85,1.25.17.69,1.27,1.25,2.45,1.25h28.69c1.19,0,2.05-.56,1.92-1.25-.12-.69-1.19-1.25-2.38-1.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M294.75,135.41h-41.16c-1.39,0-2.32.76-2.07,1.7.24.94,1.56,1.69,2.94,1.69h40.92c1.38,0,2.36-.76,2.2-1.69-.17-.94-1.43-1.7-2.82-1.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M292.76,124.56h-57.31c-1.42,0-2.34.79-2.06,1.77.28.97,1.64,1.76,3.05,1.76h56.96c1.41,0,2.41-.78,2.23-1.76-.17-.97-1.46-1.77-2.88-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M311.24,225.31h-47.49c-1.17,0-1.97.54-1.78,1.21.19.67,1.29,1.21,2.46,1.21h47.26c1.17,0,2.02-.54,1.9-1.21-.12-.67-1.17-1.21-2.34-1.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "316.07 149.54 326.78 149.54 326.25 145.45 315.45 145.45 316.07 149.54"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "317.56 159.49 328.09 159.49 327.57 155.55 316.97 155.55 317.56 159.49"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "319.01 169.1 329.35 169.1 328.85 165.29 318.43 165.29 319.01 169.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "320.4 178.38 330.57 178.38 330.08 174.7 319.85 174.7 320.4 178.38"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "321.75 187.35 331.74 187.35 331.27 183.8 321.21 183.8 321.75 187.35"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "323.05 196.03 332.88 196.03 332.43 192.59 322.53 192.59 323.05 196.03"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "324.31 204.42 333.98 204.42 333.54 201.09 323.81 201.09 324.31 204.42"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "325.53 212.54 335.05 212.54 334.62 209.32 325.05 209.32 325.53 212.54"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "326.71 220.41 336.08 220.41 335.67 217.29 326.24 217.29 326.71 220.41"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "314.52 139.22 325.43 139.22 324.87 134.98 313.88 134.98 314.52 139.22"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "312.91 128.52 324.02 128.52 323.45 124.11 312.25 124.11 312.91 128.52"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "327.86 228.03 337.08 228.03 336.68 225.01 327.4 225.01 327.86 228.03"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M384.31,210.93c-.02-.71.94-1.29,2.15-1.29h158.6c1.21,0,2.02.58,1.81,1.29-.21.71-1.35,1.29-2.55,1.29h-157.78c-1.2,0-2.2-.58-2.22-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M546.65,204.09h-87.81c-1.22,0-2.15-.59-2.07-1.33.08-.74,1.14-1.34,2.37-1.34h88.27c1.23,0,2.05.6,1.84,1.34-.21.73-1.38,1.33-2.6,1.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M437.99,204.09h-27.32c-1.22,0-2.21-.59-2.2-1.33.01-.74,1.02-1.34,2.25-1.34h27.46c1.23,0,2.18.6,2.12,1.34-.06.73-1.1,1.33-2.32,1.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M495,195.68h-123.88c-1.24,0-2.29-.61-2.34-1.37-.05-.76.93-1.38,2.18-1.38h124.53c1.25,0,2.15.62,2.01,1.38-.14.76-1.26,1.37-2.51,1.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M345.23,192.93h8.83c1.25,0,2.32.62,2.38,1.38.06.76-.89,1.37-2.14,1.37h-8.78c-1.24,0-2.32-.61-2.4-1.37-.08-.76.86-1.38,2.11-1.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M512.92,185.58c-.17.78-1.33,1.42-2.59,1.42h-116.73c-1.26,0-2.3-.63-2.32-1.42-.01-.79,1.01-1.43,2.28-1.43h117.36c1.27,0,2.17.64,2,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M344.29,184.15h33.13c1.27,0,2.33.64,2.36,1.43.03.78-.97,1.42-2.23,1.42h-32.95c-1.26,0-2.36-.63-2.45-1.42-.09-.79.87-1.43,2.14-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M343.32,175.07h127.33c1.29,0,2.25.66,2.14,1.48-.11.81-1.24,1.47-2.53,1.47h-126.64c-1.29,0-2.4-.66-2.49-1.47-.09-.81.88-1.48,2.18-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M426,168.72c-1.31,0-2.34-.68-2.31-1.52.04-.84,1.13-1.53,2.45-1.53h67.19c1.32,0,2.26.69,2.12,1.53-.15.84-1.33,1.52-2.63,1.52h-66.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M342.32,165.68h58.15c1.32,0,2.38.69,2.38,1.53,0,.84-1.07,1.52-2.38,1.52h-57.83c-1.31,0-2.45-.68-2.54-1.52-.09-.84.9-1.53,2.21-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M559.56,159.1h-160.06c-1.33,0-2.42-.7-2.42-1.57,0-.87,1.08-1.58,2.42-1.58h160.97c1.34,0,2.22.71,1.96,1.58-.25.87-1.54,1.57-2.87,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M562.42,149.13h-140.84c-1.36,0-2.43-.73-2.4-1.63.03-.9,1.16-1.64,2.52-1.64h141.66c1.36,0,2.26.74,1.99,1.64-.26.9-1.57,1.63-2.93,1.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M565.38,138.8h-29.49c-1.38,0-2.33-.76-2.11-1.69.22-.94,1.52-1.7,2.91-1.7h29.67c1.39,0,2.29.76,2.02,1.7-.27.94-1.61,1.69-2.99,1.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M515.26,138.8h-108.3c-1.38,0-2.5-.76-2.49-1.69,0-.94,1.14-1.7,2.53-1.7h108.94c1.39,0,2.36.76,2.17,1.7-.19.94-1.46,1.69-2.85,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M347.86,217.6h100.01c1.19,0,2.1.56,2.03,1.25-.07.69-1.09,1.25-2.27,1.25h-99.5c-1.19,0-2.21-.56-2.28-1.25-.08-.69.83-1.25,2.02-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M348.68,225.31h153.66c1.17,0,2.01.54,1.86,1.21-.14.67-1.2,1.21-2.37,1.21h-152.89c-1.17,0-2.17-.54-2.25-1.21-.07-.67.82-1.21,1.99-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M509.88,128.08h-78.23c-1.41,0-2.51-.78-2.46-1.76.05-.97,1.23-1.77,2.65-1.77h78.7c1.41,0,2.41.79,2.22,1.77-.19.97-1.48,1.76-2.88,1.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M409.47,128.08h-71.16c-1.41,0-2.63-.78-2.74-1.76-.11-.97.95-1.77,2.37-1.77h71.58c1.42,0,2.55.79,2.53,1.77-.02.97-1.17,1.76-2.58,1.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M470.06,217.6c1.19,0,2.08.56,1.98,1.25-.1.69-1.14,1.25-2.33,1.25h-7.73c-1.19,0-2.08-.56-2-1.25.08-.69,1.12-1.25,2.31-1.25h7.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M375.19,210.93c.04.71-.91,1.29-2.12,1.29h-10.53c-1.2,0-2.23-.58-2.28-1.29-.06-.71.88-1.29,2.09-1.29h10.59c1.21,0,2.22.58,2.26,1.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M502.23,176.55c-.15.81-1.32,1.47-2.61,1.47h-12.31c-1.29,0-2.23-.66-2.1-1.47.13-.81,1.28-1.48,2.57-1.48h12.38c1.29,0,2.22.66,2.06,1.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M540.65,184.15c1.27,0,2.13.64,1.92,1.43-.21.78-1.41,1.42-2.67,1.42h-9.81c-1.26,0-2.14-.63-1.95-1.42.19-.79,1.38-1.43,2.65-1.43h9.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M380.11,159.1c-1.33,0-2.44-.7-2.48-1.57-.04-.87,1.02-1.58,2.36-1.58h10.45c1.34,0,2.44.71,2.45,1.58.01.87-1.06,1.57-2.39,1.57h-10.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.87,108.14c.81,2.71-.75,4.88-3.48,4.88s-5.64-2.17-6.52-4.88c-.89-2.75.65-5,3.45-5s5.73,2.25,6.55,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M251.34,108.22c.72,2.71-.91,4.88-3.64,4.88s-5.57-2.17-6.36-4.88c-.8-2.75.81-5,3.61-5s5.66,2.25,6.39,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M264.97,108.14c.63,2.71-1.07,4.88-3.8,4.88s-5.5-2.17-6.2-4.88c-.71-2.75.98-5,3.77-5s5.59,2.25,6.23,5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "134.93 90.1 179.53 209.32 233.34 90.1 134.93 90.1"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "210.19 243.18 299.45 90.1 392.89 90.1 261.52 243.18 210.19 243.18"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "433.16 89.35 294.03 243.18 315.45 243.18 459.58 90.1 433.16 89.35"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "460.63 243.18 613.54 90.1 635.12 90.1 477.47 243.18 460.63 243.18"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M253.31,309.62h-34.92c-4.53,0-8.21,3.67-8.21,8.21v16.99c0,4.53,3.67,8.21,8.21,8.21h9.13l6.92,15.67,9.75-15.67h9.13c4.53,0,8.21-3.67,8.21-8.21v-16.99c0-4.53-3.67-8.21-8.21-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.43,359.53s-.04,0-.06,0c-.31-.02-.58-.21-.7-.49l-6.7-15.18h-8.59c-4.98,0-9.03-4.05-9.03-9.04v-16.99c0-4.98,4.05-9.04,9.03-9.04h34.92c4.98,0,9.04,4.05,9.04,9.04v16.99c0,4.98-4.05,9.04-9.04,9.04h-8.67l-9.51,15.28c-.15.24-.42.39-.7.39ZM218.39,310.45c-4.07,0-7.38,3.31-7.38,7.38v16.99c0,4.07,3.31,7.38,7.38,7.38h9.13c.33,0,.62.19.76.49l6.28,14.24,8.92-14.34c.15-.24.42-.39.7-.39h9.13c4.07,0,7.38-3.31,7.38-7.38v-16.99c0-4.07-3.31-7.38-7.38-7.38h-34.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M231,319.34c0-.89.72-1.59,1.7-1.59s1.7.66,1.7,1.53c0,.94-.7,1.66-1.7,1.66s-1.7-.7-1.7-1.6ZM231.36,322.8h2.66v11.36h-2.66v-11.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M240.44,322.21v.68h3.13v2.13h-3.04v9.14h-2.66v-9.14h-1.87v-2.13h1.87v-.72c0-2.38,1.42-3.93,4.06-3.93.91,0,1.81.19,2.4.62l-.74,2c-.4-.28-.91-.47-1.47-.47-1.11,0-1.68.62-1.68,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M359.6,312h-34.92c-4.53,0-8.21,3.67-8.21,8.21v16.99c0,4.53,3.67,8.21,8.21,8.21h9.13l6.92,15.67,9.75-15.67h9.13c4.53,0,8.21-3.67,8.21-8.21v-16.99c0-4.53-3.67-8.21-8.21-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M340.72,361.91s-.04,0-.06,0c-.31-.02-.58-.21-.7-.49l-6.7-15.18h-8.59c-4.98,0-9.04-4.05-9.04-9.04v-16.99c0-4.98,4.05-9.04,9.04-9.04h34.92c4.98,0,9.04,4.05,9.04,9.04v16.99c0,4.98-4.05,9.04-9.04,9.04h-8.67l-9.51,15.28c-.15.24-.42.39-.7.39ZM324.68,312.83c-4.07,0-7.38,3.31-7.38,7.38v16.99c0,4.07,3.31,7.38,7.38,7.38h9.13c.33,0,.62.19.76.49l6.28,14.24,8.92-14.34c.15-.24.42-.39.7-.39h9.13c4.07,0,7.38-3.31,7.38-7.38v-16.99c0-4.07-3.31-7.38-7.38-7.38h-34.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M332.02,331.71h-8.91c.32,1.66,1.7,2.72,3.68,2.72,1.28,0,2.28-.4,3.08-1.23l1.42,1.64c-1.02,1.21-2.62,1.85-4.57,1.85-3.81,0-6.27-2.45-6.27-5.83s2.49-5.81,5.87-5.81,5.74,2.32,5.74,5.87c0,.21-.02.53-.04.79ZM323.09,329.95h6.44c-.21-1.64-1.47-2.77-3.21-2.77s-2.98,1.11-3.23,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M334.61,320.76h2.66v15.78h-2.66v-15.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.45,335.41l1.02-2.02c1,.66,2.53,1.13,3.96,1.13,1.68,0,2.38-.47,2.38-1.25,0-2.17-7.02-.13-7.02-4.66,0-2.15,1.93-3.55,5-3.55,1.51,0,3.23.36,4.25.98l-1.02,2.02c-1.08-.64-2.17-.85-3.25-.85-1.62,0-2.38.53-2.38,1.28,0,2.3,7.02.25,7.02,4.7,0,2.13-1.96,3.51-5.15,3.51-1.89,0-3.78-.55-4.81-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M362.33,331.71h-8.91c.32,1.66,1.7,2.72,3.68,2.72,1.28,0,2.28-.4,3.08-1.23l1.42,1.64c-1.02,1.21-2.62,1.85-4.57,1.85-3.81,0-6.27-2.45-6.27-5.83s2.49-5.81,5.87-5.81,5.74,2.32,5.74,5.87c0,.21-.02.53-.04.79ZM353.4,329.95h6.44c-.21-1.64-1.47-2.77-3.21-2.77s-2.98,1.11-3.23,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M462.65,310.99h-34.92c-4.53,0-8.21,3.67-8.21,8.21v16.99c0,4.53,3.67,8.21,8.21,8.21h9.13l6.92,15.67,9.75-15.67h9.13c4.53,0,8.21-3.67,8.21-8.21v-16.99c0-4.53-3.68-8.21-8.21-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M443.78,360.9s-.04,0-.06,0c-.31-.02-.58-.21-.7-.49l-6.7-15.18h-8.59c-4.98,0-9.04-4.05-9.04-9.04v-16.99c0-4.98,4.05-9.04,9.04-9.04h34.92c4.98,0,9.04,4.05,9.04,9.04v16.99c0,4.98-4.05,9.04-9.04,9.04h-8.67l-9.51,15.28c-.15.24-.42.39-.7.39ZM427.73,311.82c-4.07,0-7.38,3.31-7.38,7.38v16.99c0,4.07,3.31,7.38,7.38,7.38h9.13c.33,0,.62.19.76.49l6.28,14.24,8.92-14.34c.15-.24.42-.39.7-.39h9.13c4.07,0,7.38-3.31,7.38-7.38v-16.99c0-4.07-3.31-7.38-7.38-7.38h-34.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M435.74,323.58v.68h3.13v2.13h-3.04v9.14h-2.66v-9.14h-1.87v-2.13h1.87v-.72c0-2.38,1.43-3.93,4.06-3.93.91,0,1.81.19,2.4.62l-.75,2c-.4-.28-.91-.47-1.47-.47-1.11,0-1.68.62-1.68,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M439.55,329.85c0-3.4,2.55-5.81,6.04-5.81s6.06,2.4,6.06,5.81-2.53,5.83-6.06,5.83-6.04-2.42-6.04-5.83ZM448.97,329.85c0-2.17-1.45-3.55-3.38-3.55s-3.36,1.38-3.36,3.55,1.45,3.55,3.36,3.55,3.38-1.38,3.38-3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M460.76,324.05v2.53c-.23-.04-.43-.06-.62-.06-2.02,0-3.3,1.19-3.3,3.51v5.51h-2.66v-11.36h2.53v1.66c.77-1.19,2.15-1.79,4.04-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M564.21,309.62h-34.92c-4.53,0-8.21,3.67-8.21,8.21v16.99c0,4.53,3.67,8.21,8.21,8.21h9.13l6.92,15.67,9.75-15.67h9.13c4.53,0,8.21-3.67,8.21-8.21v-16.99c0-4.53-3.67-8.21-8.21-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M545.34,359.53s-.04,0-.06,0c-.31-.02-.58-.21-.7-.49l-6.7-15.18h-8.59c-4.98,0-9.04-4.05-9.04-9.04v-16.99c0-4.98,4.05-9.04,9.04-9.04h34.92c4.98,0,9.04,4.05,9.04,9.04v16.99c0,4.98-4.05,9.04-9.04,9.04h-8.67l-9.51,15.28c-.15.24-.42.39-.7.39ZM529.3,310.45c-4.07,0-7.38,3.31-7.38,7.38v16.99c0,4.07,3.31,7.38,7.38,7.38h9.13c.33,0,.62.19.76.49l6.28,14.24,8.92-14.34c.15-.24.42-.39.7-.39h9.13c4.07,0,7.38-3.31,7.38-7.38v-16.99c0-4.07-3.31-7.38-7.38-7.38h-34.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M542.22,322.24h9.8v2.13h-9.8v-2.13ZM542.22,327.39h9.8v2.13h-9.8v-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M306.54,289.96h-34.92c-4.53,0-8.21,3.67-8.21,8.21v16.99c0,4.53,3.67,8.21,8.21,8.21h9.13l6.92,15.67,9.75-15.67h9.13c4.53,0,8.21-3.67,8.21-8.21v-16.99c0-4.53-3.67-8.21-8.21-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M287.66,339.87s-.04,0-.06,0c-.31-.02-.57-.21-.7-.49l-6.7-15.18h-8.59c-4.98,0-9.03-4.05-9.03-9.04v-16.99c0-4.98,4.05-9.04,9.03-9.04h34.92c4.98,0,9.04,4.05,9.04,9.04v16.99c0,4.98-4.05,9.04-9.04,9.04h-8.67l-9.51,15.28c-.15.24-.42.39-.7.39ZM271.62,290.79c-4.07,0-7.38,3.31-7.38,7.38v16.99c0,4.07,3.31,7.38,7.38,7.38h9.13c.33,0,.62.19.76.49l6.28,14.24,8.92-14.34c.15-.24.42-.39.7-.39h9.13c4.07,0,7.38-3.31,7.38-7.38v-16.99c0-4.07-3.31-7.38-7.38-7.38h-34.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M280.86,297.02h5.08v2.13h-2.42v15.65h2.42v2.13h-5.08v-19.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292.53,316.92v-2.13h2.4v-15.65h-2.4v-2.13h5.06v19.91h-5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M410.35,288.22h-34.92c-4.53,0-8.21,3.67-8.21,8.21v16.99c0,4.53,3.67,8.21,8.21,8.21h9.13l6.92,15.67,9.75-15.67h9.13c4.53,0,8.21-3.67,8.21-8.21v-16.99c0-4.53-3.67-8.21-8.21-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M391.47,338.13s-.04,0-.06,0c-.31-.02-.58-.21-.7-.49l-6.7-15.18h-8.59c-4.98,0-9.04-4.05-9.04-9.04v-16.99c0-4.98,4.05-9.04,9.04-9.04h34.92c4.98,0,9.04,4.05,9.04,9.04v16.99c0,4.98-4.05,9.04-9.04,9.04h-8.67l-9.51,15.28c-.15.24-.42.39-.7.39ZM375.43,289.05c-4.07,0-7.38,3.31-7.38,7.38v16.99c0,4.07,3.31,7.38,7.38,7.38h9.13c.33,0,.62.19.76.49l6.28,14.24,8.92-14.34c.15-.24.42-.39.7-.39h9.13c4.07,0,7.38-3.31,7.38-7.38v-16.99c0-4.07-3.31-7.38-7.38-7.38h-34.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M385.78,305.16c.85.28,1.25.85,1.25,2.17v4.04c0,1.02.51,1.62,1.57,1.62h.45v2.13h-1.06c-2.4,0-3.61-1.21-3.61-3.47v-4.38c0-.7-.36-1.02-.96-1.02h-.7v-2.17h.7c.59,0,.96-.32.96-1.02v-4.38c0-2.25,1.21-3.47,3.61-3.47h1.06v2.13h-.45c-1.06,0-1.57.6-1.57,1.62v4.04c0,1.32-.4,1.89-1.25,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M402,304.08v2.17h-.72c-.57,0-.94.32-.94,1.02v4.38c0,2.25-1.23,3.47-3.64,3.47h-1.06v-2.13h.45c1.08,0,1.6-.59,1.6-1.62v-4.04c0-1.32.38-1.89,1.23-2.17-.85-.28-1.23-.85-1.23-2.17v-4.04c0-1.02-.51-1.62-1.6-1.62h-.45v-2.13h1.06c2.4,0,3.64,1.21,3.64,3.47v4.38c0,.7.36,1.02.94,1.02h.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M513.06,284.78h-34.92c-4.53,0-8.21,3.67-8.21,8.21v16.99c0,4.53,3.67,8.21,8.21,8.21h9.13l6.92,15.67,9.75-15.67h9.13c4.53,0,8.21-3.67,8.21-8.21v-16.99c0-4.53-3.67-8.21-8.21-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M494.19,334.69s-.04,0-.06,0c-.31-.02-.58-.21-.7-.49l-6.7-15.18h-8.59c-4.98,0-9.04-4.05-9.04-9.04v-16.99c0-4.98,4.05-9.04,9.04-9.04h34.92c4.98,0,9.04,4.05,9.04,9.04v16.99c0,4.98-4.05,9.04-9.04,9.04h-8.67l-9.51,15.28c-.15.24-.42.39-.7.39ZM478.15,285.61c-4.07,0-7.38,3.31-7.38,7.38v16.99c0,4.07,3.31,7.38,7.38,7.38h9.13c.33,0,.62.19.76.49l6.28,14.24,8.92-14.34c.15-.24.42-.39.7-.39h9.13c4.07,0,7.38-3.31,7.38-7.38v-16.99c0-4.07-3.31-7.38-7.38-7.38h-34.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M494.22,297.35c0-1.06.79-1.77,1.74-1.77s1.74.7,1.74,1.77-.79,1.77-1.74,1.77-1.74-.74-1.74-1.77ZM497.7,305.46c0,.47-.11.85-.49,1.83l-1.08,3h-1.72l.85-3.25c-.59-.25-1-.81-1-1.57,0-1.06.74-1.77,1.72-1.77s1.72.72,1.72,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M376.55,581.78h34.92c4.53,0,8.21-3.67,8.21-8.21v-16.99c0-4.53-3.67-8.21-8.21-8.21h-9.13l-2.66-15.67-14,15.67h-9.13c-4.53,0-8.21,3.67-8.21,8.21v16.99c0,4.53,3.67,8.21,8.21,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M411.47,582.61h-34.92c-4.98,0-9.04-4.05-9.04-9.04v-16.99c0-4.98,4.05-9.04,9.04-9.04h8.76l13.75-15.4c.21-.24.54-.33.85-.24.31.09.53.34.59.66l2.55,14.99h8.43c4.98,0,9.04,4.05,9.04,9.04v16.99c0,4.98-4.05,9.04-9.04,9.04ZM376.55,549.21c-4.07,0-7.38,3.31-7.38,7.38v16.99c0,4.07,3.31,7.38,7.38,7.38h34.92c4.07,0,7.38-3.31,7.38-7.38v-16.99c0-4.07-3.31-7.38-7.38-7.38h-9.13c-.4,0-.75-.29-.82-.69l-2.38-13.98-12.86,14.39c-.16.18-.38.28-.62.28h-9.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M388.82,561.59l-7.34,2.74,7.34,2.74v2.21l-9.8-3.81v-2.3l9.8-3.81v2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M396.56,553.87h2.38l-7.02,20.03h-2.38l7.02-20.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M409.25,563.19v2.3l-9.8,3.81v-2.21l7.34-2.74-7.34-2.74v-2.21l9.8,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M154.55,458.07h34.92c4.53,0,8.21-3.67,8.21-8.21v-16.99c0-4.53-3.67-8.21-8.21-8.21h-9.13l1.99-15.67-18.65,15.67h-9.13c-4.53,0-8.21,3.67-8.21,8.21v16.99c0,4.53,3.67,8.21,8.21,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M189.47,458.9h-34.92c-4.98,0-9.04-4.05-9.04-9.04v-16.99c0-4.98,4.05-9.04,9.04-9.04h8.83l18.42-15.48c.26-.22.63-.26.93-.09.3.16.47.49.42.83l-1.87,14.74h8.19c4.98,0,9.04,4.05,9.04,9.04v16.99c0,4.98-4.05,9.04-9.04,9.04ZM154.56,425.49c-4.07,0-7.38,3.31-7.38,7.38v16.99c0,4.07,3.31,7.38,7.38,7.38h34.92c4.07,0,7.38-3.31,7.38-7.38v-16.99c0-4.07-3.31-7.38-7.38-7.38h-9.13c-.24,0-.46-.1-.62-.28-.16-.18-.23-.42-.2-.65l1.72-13.58-17.03,14.31c-.15.12-.34.19-.53.19h-9.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M164.91,447.29c0-.91.72-1.64,1.72-1.64s1.68.72,1.68,1.64-.7,1.66-1.68,1.66-1.72-.74-1.72-1.66ZM165.06,433.92h3.15l-.53,9.95h-2.11l-.51-9.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M170.94,437.73h9.8v2.13h-9.8v-2.13ZM170.94,442.87h9.8v2.13h-9.8v-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M713.67,438.81c0,6.82-.57,13.43-1.61,19.64-4.8,28.64-19.85,49.54-37.67,49.54-1.59,0-3.19-.18-4.73-.5-19.45-4.13-34.54-33.3-34.54-68.68,0-38.2,17.59-51.72,39.27-51.72s39.28,13.51,39.28,51.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M674.38,508.81c-1.6,0-3.25-.17-4.9-.51-20.07-4.26-35.2-34.13-35.2-69.49,0-18.11,3.94-31.81,11.71-40.73,6.83-7.84,16.38-11.82,28.39-11.82s21.57,3.98,28.4,11.82c7.77,8.91,11.71,22.61,11.71,40.73,0,6.71-.55,13.37-1.62,19.78-4.96,29.57-20.78,50.23-38.49,50.23ZM674.38,387.92c-17.54,0-38.44,8.83-38.44,50.89,0,34.6,14.57,63.78,33.88,67.87,1.53.32,3.07.48,4.56.48,16.88,0,32.04-20.09,36.85-48.85,1.06-6.32,1.6-12.88,1.6-19.51,0-42.06-20.91-50.89-38.46-50.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M695.48,473.96c-2.62,8.81-6.97,17.11-12.88,24.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M683.24,498.65l-1.27-1.06c5.7-6.81,10.1-15.07,12.72-23.87l1.59.47c-2.68,9.02-7.19,17.48-13.04,24.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M696.85,472.15l-1.6-.42c.24-.91.47-1.83.67-2.76l1.62.36c-.21.95-.44,1.89-.69,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M696.63,438.72c2.09,8.81,2.3,18.03.78,26.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M698.23,465.81l-1.63-.28c1.51-8.91,1.25-18.12-.77-26.62l1.61-.38c2.07,8.72,2.35,18.15.79,27.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M635.42,439.58l-.61-1.54c.45-.18,45.38-17.59,79.23.04l-.76,1.47c-33.17-17.27-77.42-.14-77.86.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M674.39,387.09s4.47,16.56,4.99,43.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M678.55,430.58c-.51-26.51-4.92-43.11-4.96-43.27l1.6-.43c.04.17,4.5,16.96,5.02,43.67l-1.65.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M680.62,407.23c.57,5.14-.32,9.53-1.99,9.79-1.67.26-3.49-3.69-4.07-8.84-.57-5.14.32-9.53,1.99-9.79,1.67-.26,3.49,3.69,4.07,8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M678.47,417.86c-.36,0-.83-.11-1.34-.49-1.58-1.21-2.91-4.77-3.39-9.09-.56-5.02.18-10.31,2.68-10.7.38-.06.97-.03,1.62.47,1.58,1.21,2.91,4.77,3.39,9.09.56,5.02-.18,10.31-2.68,10.7-.08.01-.18.02-.29.02ZM676.71,399.21s-.02,0-.03,0c-.79.12-1.89,3.59-1.3,8.88.47,4.21,1.74,7.19,2.75,7.96.08.06.24.17.36.15.79-.13,1.89-3.59,1.3-8.88h0c-.47-4.2-1.74-7.19-2.75-7.96-.08-.06-.22-.15-.33-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M656.77,522.05h-52.34c-6.82,0-12.64-5.08-13.55-11.82-.1-.49-.16-1.11-.16-1.88v-123.46c0-.75.05-1.37.16-1.95.9-6.68,6.72-11.76,13.54-11.76h148.5c2.3,0,4.58.59,6.58,1.69l-.8,1.45c-1.75-.97-3.75-1.49-5.77-1.49h-148.5c-5.99,0-11.11,4.46-11.91,10.37-.1.51-.14,1.03-.14,1.68v123.46c0,.66.04,1.17.13,1.6.81,5.98,5.93,10.45,11.92,10.45h52.34v1.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDeveloper);
export default __webpack_public_path__ + "static/media/web-developer.93c9172d320c18531e68942ebf7298ee.svg";
export { ForwardRef as ReactComponent };